export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
}

export interface AbandonBookingInput {
  /** Order number of the booking for abandoning */
  orderNumber: Scalars["String"];
  /** Unique identifier of the collection of products / trip */
  tripId: Scalars["UUID"];
}

/** Information necessary to create an account */
export interface AccountInformationInput {
  /** Email required for booking information to be sent to */
  email: Scalars["String"];
  /** Shows if the customer wants to receive marketing emails */
  isMarketingOptedIn?: Maybe<Scalars["Boolean"]>;
  /** Sent when account creation module present in addition to user input */
  password?: Maybe<Scalars["String"]>;
}

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = "AUTHWINDOW",
  /** Action to copy contents to clipboard */
  COPY = "COPY",
  /** Action to open the date picker */
  DATEPICKER = "DATEPICKER",
  /** Action to open an external link off */
  EXTERNAL_LINK = "EXTERNAL_LINK",
  /** Action to display free lx message */
  FREE_LX = "FREE_LX",
  /** Action to open a link off */
  OPEN = "OPEN",
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  UNKNOWN = "UNKNOWN",
  USED = "USED",
}

export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = "POSITIVE",
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
}

/** Activity banner type */
export enum ActivityBannerType {
  ALERT = "ALERT",
  INFO = "INFO",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CANCELLATION = "NO_CANCELLATION",
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = "ADULTS_ONLY_SHOWS",
  ADVENTURES = "ADVENTURES",
  ADVENTURE_OUTDOOR = "ADVENTURE_OUTDOOR",
  AIRBOAT_TOURS = "AIRBOAT_TOURS",
  AIRPLANE_RIDES = "AIRPLANE_RIDES",
  AIRPLANE_TOURS = "AIRPLANE_TOURS",
  AIRPORT_GROUND_TRANSPORTATION = "AIRPORT_GROUND_TRANSPORTATION",
  AIRPORT_LOUNGES = "AIRPORT_LOUNGES",
  AIRPORT_TO_AIRPORT_TRANSFERS = "AIRPORT_TO_AIRPORT_TRANSFERS",
  AIR_BALLOON_HELICOPTER_TOURS = "AIR_BALLOON_HELICOPTER_TOURS",
  AIR_HELICOPTER_BALLOON_TOURS = "AIR_HELICOPTER_BALLOON_TOURS",
  AMUSEMENT_THEME_PARKS = "AMUSEMENT_THEME_PARKS",
  ARCHITECTURE_TOURS = "ARCHITECTURE_TOURS",
  ART_CLASSES = "ART_CLASSES",
  ART_CULTURE_HISTORY_TOURS = "ART_CULTURE_HISTORY_TOURS",
  ART_MUSIC_LITERARYTOURS = "ART_MUSIC_LITERARYTOURS",
  ATTRACTIONS = "ATTRACTIONS",
  ATTRACTION_TICKETS = "ATTRACTION_TICKETS",
  BALLOON_RIDES = "BALLOON_RIDES",
  BALLOON_TOURS = "BALLOON_TOURS",
  BAR_PUB_TOURS = "BAR_PUB_TOURS",
  BEER_BREWERY_TOURS = "BEER_BREWERY_TOURS",
  BEYOND_THE_CITY = "BEYOND_THE_CITY",
  BIKE_MOUNTAIN_BIKE_TOURS = "BIKE_MOUNTAIN_BIKE_TOURS",
  BIKE_RENTALS = "BIKE_RENTALS",
  BOAT_RENTAL = "BOAT_RENTAL",
  BOAT_TOURS = "BOAT_TOURS",
  BOAT_TOURS_CRUISES = "BOAT_TOURS_CRUISES",
  BRUNCHC_RUISES = "BRUNCHC_RUISES",
  BUNGEE_JUMPING_SKYDIVING = "BUNGEE_JUMPING_SKYDIVING",
  BUS_MINIVAN_TOURS = "BUS_MINIVAN_TOURS",
  CABARET = "CABARET",
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  CASTLE_PALACE_TOURS = "CASTLE_PALACE_TOURS",
  CHAUFFER_SERVICES = "CHAUFFER_SERVICES",
  CHRISTMAS = "CHRISTMAS",
  CIRQUE = "CIRQUE",
  CIRQUE_DU_SOLEIL = "CIRQUE_DU_SOLEIL",
  CIRQUE_DU_SOLEILSHOWS = "CIRQUE_DU_SOLEILSHOWS",
  CITY_AND_ATTRACTION_TRANSFERS = "CITY_AND_ATTRACTION_TRANSFERS",
  CITY_ATTRACTION_TRANSFERS = "CITY_ATTRACTION_TRANSFERS",
  CITY_TOURS = "CITY_TOURS",
  CITY_TOURS_PACKAGES = "CITY_TOURS_PACKAGES",
  CLASSES_WORKSHOPS = "CLASSES_WORKSHOPS",
  CLUB_AND_PARTY_BUS_TOURS = "CLUB_AND_PARTY_BUS_TOURS",
  CLUB_PARTY_BUS_TOURS = "CLUB_PARTY_BUS_TOURS",
  COFFEE_TEA_TOURS = "COFFEE_TEA_TOURS",
  COMEDY_SHOWS = "COMEDY_SHOWS",
  CONCERTS_SPECIAL_EVENTS = "CONCERTS_SPECIAL_EVENTS",
  COOKING_CLASSES = "COOKING_CLASSES",
  CRUISES_BOAT_TOURS = "CRUISES_BOAT_TOURS",
  CRUISES_WATER_TOURS = "CRUISES_WATER_TOURS",
  CULTURAL_HERITAGE_EXPERIENCES = "CULTURAL_HERITAGE_EXPERIENCES",
  CUSTOM_PRIVATE_TOURS = "CUSTOM_PRIVATE_TOURS",
  DANCE_CLASSES = "DANCE_CLASSES",
  DAY_OF_THE_DEAD = "DAY_OF_THE_DEAD",
  DAY_SPAS = "DAY_SPAS",
  DAY_TRIPS = "DAY_TRIPS",
  DAY_TRIPS_EXCURSIONS = "DAY_TRIPS_EXCURSIONS",
  DINING_EXPERIENCES = "DINING_EXPERIENCES",
  DINNER_CRUISES = "DINNER_CRUISES",
  DINNER_THEATER = "DINNER_THEATER",
  DISNEY = "DISNEY",
  DISNEY_PARKS = "DISNEY_PARKS",
  DOLPHIN_WHALE_WATCHING = "DOLPHIN_WHALE_WATCHING",
  DOSE_OF_CULTURE = "DOSE_OF_CULTURE",
  DUCK_TOURS = "DUCK_TOURS",
  EASTER = "EASTER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FASHION_SHOWS_TOURS = "FASHION_SHOWS_TOURS",
  FISHING_CHARTERS_TOURS = "FISHING_CHARTERS_TOURS",
  FISHING_TOURS_AND_CHARTERS = "FISHING_TOURS_AND_CHARTERS",
  FOOD_DRINK = "FOOD_DRINK",
  FOOD_DRINK_NIGHTLIFE = "FOOD_DRINK_NIGHTLIFE",
  FOOD_TOURS = "FOOD_TOURS",
  FUN_FOR_FOODIES = "FUN_FOR_FOODIES",
  FUN_ON_THE_WATER = "FUN_ON_THE_WATER",
  GALLERIES_MUSEUMS = "GALLERIES_MUSEUMS",
  GAMES_SHOWS_SPECIAL_EVENTS = "GAMES_SHOWS_SPECIAL_EVENTS",
  GETTING_AROUND = "GETTING_AROUND",
  GOLF_TEE_TIMES = "GOLF_TEE_TIMES",
  GOLF_TOURS_TEE_TIMES = "GOLF_TOURS_TEE_TIMES",
  HALLOWEEN = "HALLOWEEN",
  HAMMAMS_TURKISH_BATHS = "HAMMAMS_TURKISH_BATHS",
  HELICOPTER_RIDES = "HELICOPTER_RIDES",
  HELICOPTER_TOURS = "HELICOPTER_TOURS",
  HIGH_SPEED_DRIVING = "HIGH_SPEED_DRIVING",
  HIGH_SPEED_RIDES = "HIGH_SPEED_RIDES",
  HIKING_CAMPING = "HIKING_CAMPING",
  HISTORICAL_TOURS = "HISTORICAL_TOURS",
  HISTORY_CULTURE = "HISTORY_CULTURE",
  HOLIDAY_SEASONAL_TOURS = "HOLIDAY_SEASONAL_TOURS",
  HONEYMOON_PACKAGE = "HONEYMOON_PACKAGE",
  HONEYMOON_PACKAGES = "HONEYMOON_PACKAGES",
  HOP_ON_HOP_OFF = "HOP_ON_HOP_OFF",
  HOP_ON_HOP_OFF_TOURS = "HOP_ON_HOP_OFF_TOURS",
  HORSE_CARRIAGE_RIDES = "HORSE_CARRIAGE_RIDES",
  HOT_SPRINGS_THERMAL_SPAS = "HOT_SPRINGS_THERMAL_SPAS",
  INTERESTS = "INTERESTS",
  KAYAKING_CANOEING = "KAYAKING_CANOEING",
  LATEST_GREATEST = "LATEST_GREATEST",
  LIFT_TICKETS = "LIFT_TICKETS",
  LIKELY_TO_SELL_OUT = "LIKELY_TO_SELL_OUT",
  LITERARY_ART_MUSIC_TOURS = "LITERARY_ART_MUSIC_TOURS",
  LOCAL_EXPERT_PICKS = "LOCAL_EXPERT_PICKS",
  LUNCH_CRUISES = "LUNCH_CRUISES",
  MOTORCYCLE_SCOOTER_TOURS = "MOTORCYCLE_SCOOTER_TOURS",
  MOVIE_TV_TOURS = "MOVIE_TV_TOURS",
  MULTIDAY_CRUISES = "MULTIDAY_CRUISES",
  MULTI_DAY_EXTENDED_TOURS = "MULTI_DAY_EXTENDED_TOURS",
  MUSEUM_TICKETS = "MUSEUM_TICKETS",
  MUSEUM_TICKETS_PASSES = "MUSEUM_TICKETS_PASSES",
  MUST_SEE_SIGHTS = "MUST_SEE_SIGHTS",
  NA = "NA",
  NATIONAL_HOLIDAYS = "NATIONAL_HOLIDAYS",
  NEW = "NEW",
  NEWY_EARS = "NEWY_EARS",
  NIGHTLIFE = "NIGHTLIFE",
  NIGHTLIFE_PASSES = "NIGHTLIFE_PASSES",
  NIGHT_CRUISES = "NIGHT_CRUISES",
  NIGHT_TOURS = "NIGHT_TOURS",
  ONSENS = "ONSENS",
  OTHER_ANIMALS_ACTIVITIES = "OTHER_ANIMALS_ACTIVITIES",
  OTHER_ANIMAL_ACTIVITIES = "OTHER_ANIMAL_ACTIVITIES",
  OTHER_CLASSES = "OTHER_CLASSES",
  OTHER_OUTDOOR_ACTIVITIES = "OTHER_OUTDOOR_ACTIVITIES",
  OTHER_SEASONAL_EVENTS = "OTHER_SEASONAL_EVENTS",
  OTHER_TOURS = "OTHER_TOURS",
  OTHER_TRANSFERS = "OTHER_TRANSFERS",
  OTHER_TRANSPORTATION = "OTHER_TRANSPORTATION",
  OTHER_WATER_ACTIVITIES = "OTHER_WATER_ACTIVITIES",
  PHOTOGRAPHY_TOURS = "PHOTOGRAPHY_TOURS",
  PORT_TRANSFERS = "PORT_TRANSFERS",
  PRIVATE_CUSTOM_TOURS = "PRIVATE_CUSTOM_TOURS",
  PRIVATE_DAY_TRIPS = "PRIVATE_DAY_TRIPS",
  PRIVATE_TOURS = "PRIVATE_TOURS",
  PRIVATE_TRANSFERS = "PRIVATE_TRANSFERS",
  PURE_ROMANCE = "PURE_ROMANCE",
  RELIGIOUS_SPIRITUAL_TOURS = "RELIGIOUS_SPIRITUAL_TOURS",
  RIVER_HARBOUR_CRUISES = "RIVER_HARBOUR_CRUISES",
  ROMAN_STAYCATION = "ROMAN_STAYCATION",
  SAFARIS = "SAFARIS",
  SAILING_TRIPS = "SAILING_TRIPS",
  SCOOTER_RENTALS = "SCOOTER_RENTALS",
  SEGWAY_TOURS = "SEGWAY_TOURS",
  SHARED_TRANSFERS = "SHARED_TRANSFERS",
  SHARK_DIVING = "SHARK_DIVING",
  SHOPPING_FASHION = "SHOPPING_FASHION",
  SHOPPING_PASSES_OFFERS = "SHOPPING_PASSES_OFFERS",
  SHOPPING_TOURS = "SHOPPING_TOURS",
  SHORE_EXCURIONS = "SHORE_EXCURIONS",
  SHOWS_CONCERTS = "SHOWS_CONCERTS",
  SHOW_SPORT_TICKETS = "SHOW_SPORT_TICKETS",
  SIGHTSEEING_ATTRACTION_PASSES = "SIGHTSEEING_ATTRACTION_PASSES",
  SIGHTSEEING_CITY_PASSES = "SIGHTSEEING_CITY_PASSES",
  SIGHTSEEING_PASSES = "SIGHTSEEING_PASSES",
  SKIING_RENTALS = "SKIING_RENTALS",
  SKIP_THE_LINE_TOURS = "SKIP_THE_LINE_TOURS",
  SNORKELING_SCUBA_DIVING = "SNORKELING_SCUBA_DIVING",
  SNOWBOARDING_RENTALS = "SNOWBOARDING_RENTALS",
  SNOWMOBILE_TOURS = "SNOWMOBILE_TOURS",
  SNOWSHOEING = "SNOWSHOEING",
  SPA = "SPA",
  SPA_WELLNESS = "SPA_WELLNESS",
  SPEED_BOATS_JET_SKIS = "SPEED_BOATS_JET_SKIS",
  SPORTING_EVENTS_PACKAGES = "SPORTING_EVENTS_PACKAGES",
  SPORTS_PACKAGES = "SPORTS_PACKAGES",
  STAY_ACTIVE = "STAY_ACTIVE",
  SUBMARINE_TOURS = "SUBMARINE_TOURS",
  SUNSET_CRUISES = "SUNSET_CRUISES",
  SUPERNATURAL_TOURS = "SUPERNATURAL_TOURS",
  SUSTAINABLE_TOURS = "SUSTAINABLE_TOURS",
  SWIM_WITH_DOLPHINS = "SWIM_WITH_DOLPHINS",
  THEATER_SHOWS_MUSICALS = "THEATER_SHOWS_MUSICALS",
  THEME_PARKS = "THEME_PARKS",
  THEME_PARK_TICKETS_TOURS = "THEME_PARK_TICKETS_TOURS",
  THE_GREAT_OUTDOORS = "THE_GREAT_OUTDOORS",
  THRILL_SEEKER = "THRILL_SEEKER",
  TICKETS = "TICKETS",
  TOURS_ACTIVITIES = "TOURS_ACTIVITIES",
  TOURS_SIGHTSEEING = "TOURS_SIGHTSEEING",
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  TREAT_YOURSELF = "TREAT_YOURSELF",
  TUBING = "TUBING",
  UNIVERSAL_THEME_PARKS = "UNIVERSAL_THEME_PARKS",
  VALENTINES_DAY = "VALENTINES_DAY",
  WALKING_BIKE_TOURS = "WALKING_BIKE_TOURS",
  WALKING_TOURS = "WALKING_TOURS",
  WATERSKIING_WAKEBOARDING = "WATERSKIING_WAKEBOARDING",
  WATER_ACTIVITIES = "WATER_ACTIVITIES",
  WATER_PARKS = "WATER_PARKS",
  WEDDING_CEREMONIES = "WEDDING_CEREMONIES",
  WEDDING_HONEYMOON = "WEDDING_HONEYMOON",
  WEDDING_PACKAGES = "WEDDING_PACKAGES",
  WEDDING_SHONEYMOONS = "WEDDING_SHONEYMOONS",
  WHAT_TO_DO_WITH_GROUPS = "WHAT_TO_DO_WITH_GROUPS",
  WHAT_TO_DO_WITH_KIDS = "WHAT_TO_DO_WITH_KIDS",
  WHITE_WATER_RAFTING = "WHITE_WATER_RAFTING",
  WILDLIFE_NATURE = "WILDLIFE_NATURE",
  WINE_TASTING_WINERY_TOURS = "WINE_TASTING_WINERY_TOURS",
  WINTER_ACTIVITIES = "WINTER_ACTIVITIES",
  YOGA_CLASS = "YOGA_CLASS",
  YOGA_CLASSES = "YOGA_CLASSES",
  ZOO_TICKETS = "ZOO_TICKETS",
  ZOO_TICKETS_PASSES = "ZOO_TICKETS_PASSES",
}

export enum ActivityCategoryType {
  ACTIVITIES = "ACTIVITIES",
  CATEGORIES = "CATEGORIES",
  DEALS_PROMOTIONS = "DEALS_PROMOTIONS",
  NA = "NA",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  TOURS = "TOURS",
  TRANSPORTATION = "TRANSPORTATION",
}

/** Display theme for `ActivityContentUnorderedList`. */
export enum ActivityContentUnorderedListTheme {
  /** Displayed with bullets. */
  BULLETS = "BULLETS",
  /** Displayed without bullets. */
  NO_BULLETS = "NO_BULLETS",
}

export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars["String"]>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars["String"]>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars["String"]>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars["String"]>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars["String"]>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = "NON_CONSOLIDATED_OFFERS",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = "AIR_ATTACH_MIP",
  AIR_HOTEL_ATTACH_MIP = "AIR_HOTEL_ATTACH_MIP",
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  FREE_ACTIVITY = "FREE_ACTIVITY",
  GUEST = "GUEST",
  HOTEL_ATTACH_MIP = "HOTEL_ATTACH_MIP",
  MOD = "MOD",
  STRIKE_OUT = "STRIKE_OUT",
}

export enum ActivityGroupType {
  ACTIVITY_LIST = "ACTIVITY_LIST",
  ACTIVITY_MESSAGE = "ACTIVITY_MESSAGE",
  AVAILABLE_TODAY = "AVAILABLE_TODAY",
  CATEGORY = "CATEGORY",
  FILTERED_ACTIVITIES = "FILTERED_ACTIVITIES",
  INTERESTS = "INTERESTS",
  KEYWORD_SEARCH = "KEYWORD_SEARCH",
  MORE_ACTIVITIES = "MORE_ACTIVITIES",
  NEIGHBOURHOOD = "NEIGHBOURHOOD",
  PINNED_ACTIVITY = "PINNED_ACTIVITY",
  POI = "POI",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  SLIM_CATEGORY = "SLIM_CATEGORY",
  SUB_CATEGORIES = "SUB_CATEGORIES",
  SUB_CATEGORY = "SUB_CATEGORY",
  TOP_ACTIVITIES = "TOP_ACTIVITIES",
  XSELL_RECOMMENDATIONS = "XSELL_RECOMMENDATIONS",
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = "ACTIVITY_LIST",
  ACTIVITY_SPANNED_TILE_LIST = "ACTIVITY_SPANNED_TILE_LIST",
  ACTIVITY_TILES_CAROUSEL = "ACTIVITY_TILES_CAROUSEL",
  CATEGORY_TILES_CAROUSEL = "CATEGORY_TILES_CAROUSEL",
  KEYWORD_SEARCH = "KEYWORD_SEARCH",
  MESSAGE = "MESSAGE",
  SLIM_CATEGORY_TILES_CAROUSEL = "SLIM_CATEGORY_TILES_CAROUSEL",
  TEXT = "TEXT",
}

export enum ActivityMapGroupType {
  POI = "POI",
}

/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: Maybe<Scalars["Int"]>;
  /** field which identifies sem channel */
  sem?: Maybe<Scalars["String"]>;
  /** field which identifies semdtl value */
  semdtl?: Maybe<Scalars["String"]>;
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = "ADDON",
  EARN_2X_REWARD_POINTS = "EARN_2X_REWARD_POINTS",
  GIFTING_LX_BANNER = "GIFTING_LX_BANNER",
  LOGIN = "LOGIN",
  SOURCED_CAMPAIGN = "SOURCED_CAMPAIGN",
  SUMMER_CAMPAIGN_PRIMARY = "SUMMER_CAMPAIGN_PRIMARY",
  SUMMER_CAMPAIGN_SECONDARY = "SUMMER_CAMPAIGN_SECONDARY",
}

/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars["String"];
  productToken: Scalars["String"];
}

export interface ActivityOfferFilterInput {
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
  tickets?: Maybe<Array<ActivityTicketInput>>;
}

export enum ActivityOfferUdsToken {
  SELECTED = "SELECTED",
  UNSELECTED = "UNSELECTED",
}

/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = "HTTP_EQUIV",
  NAME = "NAME",
  PROPERTY = "PROPERTY",
}

/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = "ACTIVITY_INFO",
}

/** Activity Price types */
export enum ActivityPriceType {
  GROUP = "GROUP",
  NORMAL = "NORMAL",
  VOLUME_BASED = "VOLUME_BASED",
}

export enum ActivityRedemptionType {
  PRINT = "PRINT",
  VOUCHER_LESS = "VOUCHER_LESS",
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
}

/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: Maybe<Scalars["String"]>;
  /** Filter results by activity category, supported with legacy categories */
  categories?: Maybe<Array<ActivityCategory>>;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: Maybe<Array<Scalars["String"]>>;
  /** Filter results by user provided free text search keyword */
  keyword?: Maybe<Scalars["String"]>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: Maybe<Scalars["String"]>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
}

/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = "CATEGORY",
  FILTER_NESTED_CATEGORIES = "FILTER_NESTED_CATEGORIES",
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = "GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER",
  GIFTING_ACTIVITIES = "GIFTING_ACTIVITIES",
  GUEST_PROMO = "GUEST_PROMO",
  NON_CONSOLIDATED_OFFERS = "NON_CONSOLIDATED_OFFERS",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
  SHOW_GT_BANNER = "SHOW_GT_BANNER",
}

/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = "DISTANCE_FROM_HOTEL_TO_ACTIVITY",
  FILTER_NESTED_CATEGORIES = "FILTER_NESTED_CATEGORIES",
  NEARBY_ACTIVITIES = "NEARBY_ACTIVITIES",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
  SHOW_GT_BANNER = "SHOW_GT_BANNER",
  TRAVEL_DISTANCE_FROM_HOTEL = "TRAVEL_DISTANCE_FROM_HOTEL",
}

export interface ActivitySelectedValueInput {
  id: Scalars["String"];
  value: Scalars["String"];
}

/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  DISTANCE_FROM_HOTEL = "DISTANCE_FROM_HOTEL",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  RECOMMENDED = "RECOMMENDED",
}

export enum ActivityTextAlignment {
  CENTRE = "CENTRE",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum ActivityTextSize {
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}

export interface ActivityTicketInput {
  code: Scalars["String"];
  count: Scalars["Int"];
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = "MULTI_SELECT_LIST",
  MULTI_SELECT_RANGE = "MULTI_SELECT_RANGE",
  SINGLE_SELECT = "SINGLE_SELECT",
  TEXT = "TEXT",
}

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: Maybe<Scalars["String"]>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars["String"]>;
  /** RegionCode from residency selection of user */
  regionCode?: Maybe<Scalars["String"]>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: Maybe<Array<Scalars["String"]>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars["String"];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars["String"];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars["String"];
  offerTypeId: Scalars["Int"];
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = "EXPEDIA_COLLECT",
  HOTEL_COLLECT = "HOTEL_COLLECT",
}

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = "DEBUG",
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = "NONE",
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = "PREVIEW",
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = "RELEASED",
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BARBECUE = "BARBECUE",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BREAKFAST_INCLUDED = "BREAKFAST_INCLUDED",
  BREAKFAST_NOT_AVAILABLE = "BREAKFAST_NOT_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FIRE_PLACE = "FIRE_PLACE",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCEL = "FREE_CANCEL",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FREE_WIRED_INTERNET = "FREE_WIRED_INTERNET",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  INTERNET_NOT_AVAILABLE = "INTERNET_NOT_AVAILABLE",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  NON_REFUNDABLE = "NON_REFUNDABLE",
  ON_PRIVATE_BEACH = "ON_PRIVATE_BEACH",
  ON_THE_BEACH = "ON_THE_BEACH",
  OUTDOOR_SPACE = "OUTDOOR_SPACE",
  PARKING = "PARKING",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESERVE_NOW_PAY_DEPOSIT = "RESERVE_NOW_PAY_DEPOSIT",
  RESERVE_NOW_PAY_LATER = "RESERVE_NOW_PAY_LATER",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WASHER = "WASHER",
  WATERSLIDE = "WATERSLIDE",
  WIFI_SURCHARGE = "WIFI_SURCHARGE",
  WIRED_INTERNET_SURCHARGE = "WIRED_INTERNET_SURCHARGE",
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:3 */
  FOUR_THREE = "FOUR_THREE",
  /** Aspect ratio 1:1 */
  ONE_ONE = "ONE_ONE",
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = "SIXTEEN_NINE",
  /** Aspect ratio 3:4 */
  THREE_FOUR = "THREE_FOUR",
  /** Aspect ratio 3:2 */
  THREE_TWO = "THREE_TWO",
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = "TWENTY_ONE_NINE",
}

export enum AuthenticationState {
  ANONYMOUS = "ANONYMOUS",
  AUTHENTICATED = "AUTHENTICATED",
  IDENTIFIED = "IDENTIFIED",
}

export enum BadgeIcon {
  ACCESS_TIME = "ACCESS_TIME",
  ADD = "ADD",
  BUNDLED_SAVINGS_PLUS = "BUNDLED_SAVINGS_PLUS",
  EXP29639_ORB = "EXP29639_ORB",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO_OUTLINE = "INFO_OUTLINE",
  LOB_DEALS = "LOB_DEALS",
  LOCAL_OFFER = "LOCAL_OFFER",
  MOD = "MOD",
  SMARTPHONE = "SMARTPHONE",
}

/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;
  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: Scalars["String"];
}

export interface BookingInput {
  /** Container for account creation information */
  accountInformation?: Maybe<AccountInformationInput>;
  cars?: Maybe<Array<BookingCarInput>>;
  /** Email required for booking information to be sent to */
  email: Scalars["String"];
  /** List of ways to pay for the booking. */
  paymentMethods: Array<PaymentMethodInput>;
  properties?: Maybe<Array<BookingPropertyInput>>;
  /** Total price of the booking */
  totalPrice?: Maybe<MoneyInput>;
  /** The users traveler id for Spanish tax regulation requirements */
  travelerId?: Maybe<Scalars["String"]>;
  /** Unique identifier of the collection of products / trip */
  tripId: Scalars["UUID"];
  /** Encoded string representing the most up to date state of the trip. The value to use can be found in the response of the checkout query. */
  tripState: Scalars["String"];
  /** Trust payload to send for fraud checking */
  trustPayload?: Maybe<Scalars["String"]>;
}

export interface BookingProductDetailsInput {
  businessModel: BusinessModel;
  lineOfBusiness: LineOfBusiness;
}

/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;
  phoneNumber: PhoneNumberInput;
  preferences?: Maybe<PropertyPreferencesInput>;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: Scalars["String"];
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: Maybe<Scalars["Boolean"]>;
}

export enum BookingStatus {
  ABANDONED = "ABANDONED",
  ANY = "ANY",
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  NO_LONGER_AVAILABLE = "NO_LONGER_AVAILABLE",
  PARTIALLY_FAILED = "PARTIALLY_FAILED",
  PENDING = "PENDING",
  PLANNING = "PLANNING",
  POSSIBLE = "POSSIBLE",
  SAVED = "SAVED",
  UNKNOWN = "UNKNOWN",
}

export enum BooleanEnum {
  FALSE = "FALSE",
  TRUE = "TRUE",
}

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars["String"];
  value: Scalars["Boolean"];
}

/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}

/** Business model for a product */
export enum BusinessModel {
  CLASSIC_AGENCY = "CLASSIC_AGENCY",
  DIRECT_AGENCY = "DIRECT_AGENCY",
  MERCHANT = "MERCHANT",
}

export enum ButtonType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

export enum CampaignOfferBadgeType {
  DEFAULT = "DEFAULT",
  DISCOUNT = "DISCOUNT",
}

export interface CampaignParametersInput {
  campaignId: Scalars["String"];
  contentPagination?: Maybe<ContentPaginationInput>;
  propertyParameters?: Maybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = "ACTIVITY",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
  PACKAGE = "PACKAGE",
}

export interface CampaignPropertyParametersInput {
  guestRating?: Maybe<Scalars["Float"]>;
  propertyId: Scalars["String"];
  starRating?: Maybe<Scalars["Float"]>;
  type?: Maybe<PropertyDetailsPropertyType>;
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = "NOT_SELECTED",
  SELECTED = "SELECTED",
}

export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = "APPLY_LOYALTY_POINTS",
  /** Click map marker */
  CAR_MAP_MARKER = "CAR_MAP_MARKER",
  /** Dismisses a dialog */
  DISMISS = "DISMISS",
  /** Click to filter car sales */
  FILTER_SALE_OFFER = "FILTER_SALE_OFFER",
  /** Submit content to server */
  FORM_SUBMISSION = "FORM_SUBMISSION",
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = "GO_BACK_TO_SEARCH",
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = "GO_TO_CANCELLATION_POLICY",
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = "GO_TO_CHECKOUT",
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = "GO_TO_CLEANLINESS_DIALOG",
  /** Continues to the standalone details page */
  GO_TO_DETAILS = "GO_TO_DETAILS",
  /** Continues to the packages path */
  GO_TO_PACKAGES = "GO_TO_PACKAGES",
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = "GO_TO_RECOMMENDED_SORT_FAQ",
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = "GO_TO_SIGNIN",
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = "GO_TO_SIGNUP",
  /** Load more results to search page */
  LOAD_MORE = "LOAD_MORE",
  /** Opens a dialog */
  OPEN_DIALOG = "OPEN_DIALOG",
  /** Open merchant rules in iframe */
  OPEN_DOC = "OPEN_DOC",
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = "OPEN_INLINE_WIZARD",
  /** Opens a new tab */
  OPEN_NEW_TAB = "OPEN_NEW_TAB",
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = "OPEN_ON_CURRENT_TAB",
  /** Open vendor rules from domain rules */
  OPEN_RULE = "OPEN_RULE",
  /** Used to open Telephone Link */
  OPEN_TEL = "OPEN_TEL",
  /** Refreshes the current page */
  REFRESH = "REFRESH",
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = "REMOVE_LOYALTY_POINTS",
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = "SEE_CARS_AT_MAP_MARKER",
  /** Open share feedback form */
  SHARE_FEEDBACK = "SHARE_FEEDBACK",
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = "SHOW_AARP_EXCLUSIVE_OFFERS",
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = "SHOW_FREE_CANCELLATION_OFFERS",
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = "UNLOCK_CAR_SALES",
  /** Click to unlock car sales by clicking on unlock offer */
  UNLOCK_SALE_OFFER = "UNLOCK_SALE_OFFER",
}

export interface CarDetailContextInput {
  carOfferToken: Scalars["String"];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars["String"]>;
  rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>;
  selectedAccessories?: Maybe<Array<Scalars["String"]>>;
}

export enum CarFormatStyle {
  IFRAME = "IFRAME",
  LIST = "LIST",
}

export enum CarLabelTheme {
  CLICKABLE = "CLICKABLE",
}

export enum CarMapMarkerType {
  CARMARKER = "CarMarker",
  PLACEMARKER = "PlaceMarker",
}

/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars["String"];
  specialEquipments?: Maybe<Array<SpecialEquipment>>;
}

/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: Maybe<Scalars["String"]>;
  coordinates?: Maybe<CoordinatesInput>;
  regionId?: Maybe<Scalars["String"]>;
  searchTerm?: Maybe<Scalars["String"]>;
}

export enum CarRouteType {
  ONEWAY = "ONEWAY",
  ROUNDTRIP = "ROUNDTRIP",
}

export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken: Scalars["String"];
}

/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

/** Enum class to represent the type of carry on bag */
export enum CarryOnBagType {
  CARRY_ON_BAG = "CARRY_ON_BAG",
}

export enum CarsDialogType {
  LIMITED_RESULTS = "LIMITED_RESULTS",
}

export enum CarsRichTextStyle {
  BOLD = "BOLD",
  BULLET = "BULLET",
  ITALICIZE = "ITALICIZE",
}

/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars["String"];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}

export enum CartTtl {
  FIVE_MINUTES = "FIVE_MINUTES",
  SEVEN_DAYS = "SEVEN_DAYS",
  TWELVE_HOURS = "TWELVE_HOURS",
}

/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = "CANCEL",
  CHANGE = "CHANGE",
  VIEW_BOOKING = "VIEW_BOOKING",
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = "FLIGHT",
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = "CREDIT_REDEMPTION",
}

/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = "CLICKSTREAM",
  GLASSBOX = "GLASSBOX",
}

/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars["String"];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars["String"];
}

/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = "V1",
  V2 = "V2",
}

/** Describes a coupon. Please provide a value to just one of the optional arguments. */
export interface CheckoutCouponInput {
  /** A coupon value entered by the user */
  code?: Maybe<Scalars["String"]>;
  /** A coupon id value that the user selected from the list of available coupons */
  id?: Maybe<Scalars["String"]>;
}

/** Represents the mode of input */
export enum CheckoutInputMode {
  NUMERIC = "NUMERIC",
}

export enum CheckoutModule {
  INSURANCE = "INSURANCE",
  NONE = "NONE",
  PAYMENTS = "PAYMENTS",
}

/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars["String"];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = "FENCING_ATTRIBUTES",
  META_DEEPLINK = "META_DEEPLINK",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

export enum CheckoutServiceResult {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  /** Represents uitk expando link */
  EXPANDO_LINK = "EXPANDO_LINK",
  /** Represents html heading */
  HEADING = "HEADING",
}

/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  /** Represents html checkbox */
  CHECKBOX = "CHECKBOX",
  /** Represents html select */
  SELECT = "SELECT",
  /** Represents html textarea */
  TEXTAREA = "TEXTAREA",
}

/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  /** Special requests accessibility input */
  ACCESSIBILITY_INPUT = "ACCESSIBILITY_INPUT",
  /** Special request bedding input */
  BEDDING_INPUT = "BEDDING_INPUT",
  /** Special request smoking input */
  SMOKING_INPUT = "SMOKING_INPUT",
  /** Special request free text input */
  SPECIAL_REQUEST_TEXT = "SPECIAL_REQUEST_TEXT",
}

/** Represents the size of a Text element */
export enum CheckoutTextSize {
  LARGE = "LARGE",
  REGULAR = "REGULAR",
  SMALL = "SMALL",
}

export enum CheckoutUiActionType {
  INSURANCE = "INSURANCE",
  PAGE_LOAD = "PAGE_LOAD",
  SIGN_IN = "SIGN_IN",
}

/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars["Int"];
}

export enum ChronoUnit {
  CENTURIES = "CENTURIES",
  DAYS = "DAYS",
  DECADES = "DECADES",
  ERAS = "ERAS",
  FOREVER = "FOREVER",
  HALFDAYS = "HALFDAYS",
  HOURS = "HOURS",
  MICROS = "MICROS",
  MILLENNIA = "MILLENNIA",
  MILLIS = "MILLIS",
  MINUTES = "MINUTES",
  MONTHS = "MONTHS",
  NANOS = "NANOS",
  SECONDS = "SECONDS",
  WEEKS = "WEEKS",
  YEARS = "YEARS",
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = "ENHANCED_CLEANING",
}

/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars["String"];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: Maybe<Scalars["String"]>;
}

/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars["String"];
  /** URL of HTTP Request */
  url: Scalars["String"];
}

export enum CommissionTier {
  BASIC = "BASIC",
  BASIC_PLUS = "BASIC_PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_PLUS = "PREMIUM_PLUS",
}

/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = "CAP",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NA = "NA",
}

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = "DEFAULT",
  IMPORTANT = "IMPORTANT",
}

export interface ContentPaginationInput {
  pageNumber: Scalars["Int"];
  pageSize?: Maybe<Scalars["Int"]>;
}

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: Maybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: Maybe<Scalars["String"]>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: Maybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: Maybe<Scalars["Int"]>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: Maybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars["Locale"];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars["Int"];
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars["Float"];
  /** The longitude of the point in degrees */
  longitude: Scalars["Float"];
}

export enum CrossSellProductType {
  ACTIVITY = "ACTIVITY",
  CAR = "CAR",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
}

/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars["String"];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars["String"];
  /** The country code of User's current location. ex: US */
  country: Scalars["String"];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars["String"];
}

export enum CruiseBadgeTheme {
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
}

export enum CruiseFeature {
  MEMBER_DEALS = "MEMBER_DEALS",
}

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: Maybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: Maybe<Scalars["String"]>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: Maybe<Scalars["String"]>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: Maybe<Scalars["Boolean"]>;
}

/** Information about a specific currency */
export interface CurrencyInput {
  /** The ISO 4217 3-letter code for this currency */
  code: Scalars["String"];
  /** The display name of the currency */
  name: Scalars["String"];
  /** The currency symbol, e.g. '$' */
  symbol: Scalars["String"];
}

/** Gender of the customer */
export enum CustomerGender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  UNKNOWN = "UNKNOWN",
}

/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  /** Type of primary button */
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  /** Type of secondary button */
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  /** Type of tertiary button */
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = "NEW_TAB",
  SAME_TAB = "SAME_TAB",
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = "ANCHOR",
  APP_DOWNLOAD_LINK = "APP_DOWNLOAD_LINK",
  BUTTON = "BUTTON",
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = "FORM",
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = "PAGE",
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = "ERROR",
  /** Type of success for the message */
  SUCCESS = "SUCCESS",
  /** Type of warning for the message */
  WARNING = "WARNING",
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = "INVALID_INPUT",
  /** SERVICE_ERROR message */
  SERVICE_ERROR = "SERVICE_ERROR",
  /** SUCCESS message */
  SUCCESS = "SUCCESS",
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: Maybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is starred */
  star?: Maybe<Scalars["Boolean"]>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars["String"]>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars["URL"]>;
  /** regionId number */
  regionId?: Maybe<Scalars["String"]>;
  /** list of GAIA regionIds */
  regionIds?: Maybe<Array<Scalars["String"]>>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars["String"]>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars["String"]>;
  /** property id */
  propertyId?: Maybe<Scalars["String"]>;
  /** regionId number */
  regionId?: Maybe<Scalars["String"]>;
}

/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = "EMPHASIS",
  /** Bold styling */
  IMPORTANT = "IMPORTANT",
  /** Represents no style or regular text */
  STANDARD = "STANDARD",
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = "APP_DOWNLOAD",
  APP_HERO = "APP_HERO",
  CITI_COBRAND = "CITI_COBRAND",
  CITI_COBRAND_VERTICAL = "CITI_COBRAND_VERTICAL",
  GDPR = "GDPR",
  GENERIC = "GENERIC",
  MAD_MARQUEE = "MAD_MARQUEE",
  NONE = "NONE",
  OSANO = "OSANO",
  TRAVEL_ADVISORY = "TRAVEL_ADVISORY",
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars["String"];
  /** Represents the value of customer notification user input */
  value: Scalars["String"];
}

export enum DamageLiability {
  COF = "COF",
  RDD = "RDD",
}

export enum DashboardType {
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  PERFORMANCE = "PERFORMANCE",
}

/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars["Int"];
  /** The numeric month, e.g. `1` for January */
  month: Scalars["Int"];
  /** The four-digit year e.g. `1999` */
  year: Scalars["Int"];
}

export enum DatePickerMode {
  DOUBLE_DATE_SELECT_MODE = "DOUBLE_DATE_SELECT_MODE",
  SINGLE_DATE_SELECT_MODE = "SINGLE_DATE_SELECT_MODE",
}

export enum DatePickerOption {
  BUTTON_SUBTEXT_SHOW_NIGHTS = "BUTTON_SUBTEXT_SHOW_NIGHTS",
}

/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars["Int"];
  /** The hour of the datetime */
  hour: Scalars["Int"];
  /** The minute of the hour */
  minute: Scalars["Int"];
  /** The numeric month of the date */
  month: Scalars["Int"];
  /** The second of the minute */
  second: Scalars["Int"];
  /** The four-digit year of the date */
  year: Scalars["Int"];
}

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars["String"];
  value: DateInput;
}

export enum DealType {
  AARP = "AARP",
  POINTS_PROMOTION = "POINTS_PROMOTION",
}

/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: Maybe<AlterMode>;
}

export interface DestinationImageDimensionsInput {
  height: Scalars["Int"];
  width: Scalars["Int"];
}

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: Maybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: Maybe<Scalars["String"]>;
  /** List of property IDs to return search information for. */
  propertyIds?: Maybe<Array<Scalars["String"]>>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars["String"]>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: Maybe<Scalars["String"]>;
}

/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = "APP_PHONE",
  APP_TABLET = "APP_TABLET",
  CHAT_APP = "CHAT_APP",
  DESKTOP = "DESKTOP",
  MOBILE_PHONE = "MOBILE_PHONE",
  MOBILE_TABLET = "MOBILE_TABLET",
  VOICE_APP = "VOICE_APP",
}

/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars["Float"];
  height: Scalars["Float"];
  width: Scalars["Float"];
}

/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = "KILOMETER",
  MILE = "MILE",
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsHeadingStyle {
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  H5 = "H5",
  H6 = "H6",
  H7 = "H7",
  H8 = "H8",
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EgdsIconPosition {
  LEADING = "LEADING",
  TRAILING = "TRAILING",
}

/** Represents the size of the text in a EGDS Standard Link */
export enum EgdsLinkSize {
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsParagraphStyle {
  P1 = "P1",
  P2 = "P2",
  P3 = "P3",
}

export enum EgdsTextListItemStyle {
  DEFAULT = "DEFAULT",
  EMPHASIS = "EMPHASIS",
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
}

/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EgdsTextListSize {
  LIST_1 = "LIST_1",
  LIST_2 = "LIST_2",
  LIST_3 = "LIST_3",
}

export enum EventType {
  ITINACTIVECAR = "ItinActiveCar",
  ITINACTIVECRUISE = "ItinActiveCruise",
  ITINACTIVEFLIGHT = "ItinActiveFlight",
  ITINACTIVEGT = "ItinActiveGT",
  ITINACTIVEHOTEL = "ItinActiveHotel",
  ITINACTIVELX = "ItinActiveLX",
  ITINACTIVEPACKAGEFH = "ItinActivePackageFH",
  ITINACTIVERAIL = "ItinActiveRail",
  ITINCANCELLATION = "ItinCancellation",
  TRIPSHEROMODULECURRENTTRIP = "TripsHeroModuleCurrentTrip",
  TRIPSHEROMODULEPOTENTIALTRIP = "TripsHeroModulePotentialTrip",
  TRIPSHEROMODULEUPCOMINGTRIP = "TripsHeroModuleUpcomingTrip",
  TRIPSITEMDETAILVIEWED = "TripsItemDetailViewed",
  TRIPSLISTVIEWED = "TripsListViewed",
  TRIPSMODULEDESTINATIONGUIDE = "TripsModuleDestinationGuide",
  TRIPSOVERVIEWVIEWED = "TripsOverviewViewed",
  TRIPSTRAVELPLANNERITINNUMBERPRESENT = "TripsTravelPlannerItinNumberPresent",
  UNKNOWN = "Unknown",
}

export enum ExpLineOfBusiness {
  ACTIVITIES = "ACTIVITIES",
  CAR = "CAR",
  CRUISES = "CRUISES",
  FLIGHT = "FLIGHT",
  GROUNDTRANSFERS = "GROUNDTRANSFERS",
  HOTEL = "HOTEL",
  PACKAGES = "PACKAGES",
  RAILS = "RAILS",
  UNCLASSIFIED = "UNCLASSIFIED",
}

/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars["Int"];
  /** The numeric Abacus ID for an experiment */
  id: Scalars["String"];
}

export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = "CARD_ON_FILE_DAMAGE_LIABILITY",
  DEFAULT = "DEFAULT",
  DEFAULT_SUPPLIER_COLLECTED = "DEFAULT_SUPPLIER_COLLECTED",
  GROUPED_MANDATORY_FEES = "GROUPED_MANDATORY_FEES",
  L26_TAX_BREAKOUT = "L26_TAX_BREAKOUT",
  NORMAL = "NORMAL",
  OTHER = "OTHER",
  PER_PERSON_PER_NIGHT = "PER_PERSON_PER_NIGHT",
  PROPERTY = "PROPERTY",
  REFUNDABLE_DAMAGE_DEPOSIT = "REFUNDABLE_DAMAGE_DEPOSIT",
  RESORT = "RESORT",
}

export enum FeedbackPlacement {
  FIELD = "FIELD",
  MODULE = "MODULE",
  PAGE = "PAGE",
}

/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = "NO_CHANGE_FEE",
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = "CARRY_ON_BAG",
  FIRST_CHECKED_BAG = "FIRST_CHECKED_BAG",
  NO_CANCEL_FEE = "NO_CANCEL_FEE",
  NO_CHANGE_FEE = "NO_CHANGE_FEE",
  SEAT_CHOICE = "SEAT_CHOICE",
}

export enum FlightCabinClassInfo {
  BUSINESS = "BUSINESS",
  COACH = "COACH",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}

/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = "CAR",
  HOTEL = "HOTEL",
}

/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars["String"];
  productTokens: Array<Scalars["String"]>;
  travelers: Array<TravelerDetailsInput>;
}

/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = "PRIMARY",
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = "RADIO_BUTTON",
  /** Secondary action. */
  SECONDARY = "SECONDARY",
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = "TERTIARY",
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = "TOGGLE",
}

/** Available action types an actionable element */
export enum FlightsActionType {
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = "APPLY_FARE",
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = "CHOOSE_FARE",
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = "CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG",
  /** Go to coupon credit page */
  COUPON_CREDIT = "COUPON_CREDIT",
  /** Dismisses a dialog */
  DISMISS = "DISMISS",
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = "ENABLE_SUGGESTED_FILTER",
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = "FETCH_SEARCH_LISTINGS",
  /** Go to Checkout page */
  GO_TO_CHECKOUT = "GO_TO_CHECKOUT",
  /** Continues to the standalone details page */
  GO_TO_DETAILS = "GO_TO_DETAILS",
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = "GO_TO_NEXT_JOURNEY",
  /** Continues to the packages path */
  GO_TO_PACKAGES = "GO_TO_PACKAGES",
  /** Redirects to flights search page */
  GO_TO_SEARCH = "GO_TO_SEARCH",
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = "GO_TO_STOREFRONT",
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = "LOAD_CROSS_SELL_DIALOG",
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = "LOAD_STANDARD_OFFER_FARE_RULE_MODULE",
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = "LOAD_TAX_BREAKDOWN_DIALOG",
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = "OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG",
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = "OPEN_FARE_SEAT_MAP_SEAT_SHEET",
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = "OPEN_FARE_SEAT_MAP_VIEW",
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = "OPEN_FARE_SEAT_SELECT_VIEW",
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = "OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG",
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = "OPEN_LEGEND_INFO_SHEET_MOBILE",
  /** Open price summary */
  OPEN_PRICE_SUMMARY = "OPEN_PRICE_SUMMARY",
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = "REDIRECT_TO_AIRLINES_FOR_BOOKING",
  /** Refreshes the current page */
  REFRESH = "REFRESH",
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = "SEARCH_FORM_ADD_JOURNEY",
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = "SEARCH_FORM_CLOSE_BUTTON",
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = "SEARCH_FORM_REMOVE_JOURNEY",
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = "SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG",
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = "SEAT_MAP_CONTINUE_BOOKING",
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = "SEAT_MAP_NEXT_FLIGHT",
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = "SEAT_MAP_SAVE_AND_EXIT",
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = "SEAT_MAP_STAY_HERE",
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = "SEAT_SELECT_PREVIEW_FOR_TRAVELER",
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = "SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG",
  /** Select the seat */
  SELECT_SEAT = "SELECT_SEAT",
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = "SHARE_FEEDBACK",
  /** Open a modal showing details of Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = "SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS",
  /** Unselect the selected seat */
  UNSELECT_SEAT = "UNSELECT_SEAT",
}

/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = "NONSTOP",
  REFUNDABLE = "REFUNDABLE",
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars["Int"];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars["String"];
}

/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars["String"];
}

/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  NOTIFICATION = "NOTIFICATION",
  SAVED = "SAVED",
  SPONSORED = "SPONSORED",
  SUPPLIER_PROMO = "SUPPLIER_PROMO",
  VIEWED = "VIEWED",
  VIP = "VIP",
}

/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = "BUSINESS",
  COACH = "COACH",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}

/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
}

/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  numOfCheckedBags: Scalars["Int"];
}

/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars["String"];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars["String"];
  /** Represents Price of the selected flight */
  originalPrice?: Maybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars["String"]>;
}

/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars["String"]>;
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = "FADE",
  NONE = "NONE",
}

/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = "SMART_NFF_ALTERNATE_SUGGESTION",
}

/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars["Int"];
  flightsDisplayComponent: FlightsDisplayComponent;
}

/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: Maybe<Array<FlightsDisplayComponentCountingValueInput>>;
}

/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars["Int"];
}

/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
  UNDEFINED = "UNDEFINED",
}

/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = "BASE_AND_UPSELL",
  ONLY_BASE = "ONLY_BASE",
  ONLY_UPSELL = "ONLY_UPSELL",
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = "ARRIVAL_AIRPORT",
  ARRIVAL_TIME = "ARRIVAL_TIME",
  CARRY_ON_BAG = "CARRY_ON_BAG",
  CHECKED_BAG = "CHECKED_BAG",
  DEPARTURE_AIRPORT = "DEPARTURE_AIRPORT",
  DEPARTURE_TIME = "DEPARTURE_TIME",
  DURATION = "DURATION",
  FLEXIBLE_CHANGE_POLICIES = "FLEXIBLE_CHANGE_POLICIES",
  NO_CANCEL_FEE = "NO_CANCEL_FEE",
  NO_CHANGE_FEE = "NO_CHANGE_FEE",
  NUM_OF_STOPS = "NUM_OF_STOPS",
  PREFERRED_AIRLINE = "PREFERRED_AIRLINE",
  SEAT_CHOICE = "SEAT_CHOICE",
  TRAVEL_AND_BAGGAGE = "TRAVEL_AND_BAGGAGE",
}

/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = "FLEX_SEARCH",
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = "FLEX_SEARCH_GRID",
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = "FLEX_SEARCH_NOT_APPLICABLE",
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = "DEFAULT",
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = "SEARCHED_DATE_HEADER",
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = "DEFAULT",
}

export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = "DEFAULT_PRICE",
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = "HIGHEST_PRICE",
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = "LOWEST_PRICE",
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = "NO_PRICE",
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = "SEARCHED_DATE",
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = "SEARCHED_DATE_LOWEST_PRICE",
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = "SEARCHED_DATE_NO_PRICE",
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = "SEARCHED_DATE_UNAVAILABLE_FLIGHTS",
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = "UNAVAILABLE_FLIGHTS",
}

/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: Maybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars["String"];
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: Maybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars["String"];
}

/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = "LISTINGS_SUPPLY_RESPONSE_TIME",
}

/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}

/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}

/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = "EMPHASIS",
  /** Bold styling */
  IMPORTANT = "IMPORTANT",
  /** Represents no style or regular text */
  STANDARD = "STANDARD",
}

/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = "IMMEDIATE",
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = "SORT_FILTERS_SERVER_ERROR",
}

/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = "FREE_CANCELLATION",
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = "LOYALTY_REWARD",
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = "NO_CHANGE_FEES",
  /** Represents the placard of type passport */
  PASSPORT = "PASSPORT",
  /** Represents the placard of type price change */
  PRICE_CHANGE = "PRICE_CHANGE",
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = "SPLIT_TICKET",
}

/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars["String"];
}

/** Represents the sections available in the price range indicator */
export enum FlightsPriceRangeIndicatorPinPlacement {
  LOWER = "LOWER",
  MID = "MID",
  UPPER = "UPPER",
}

/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = "LOADED",
  LOADING = "LOADING",
}

export interface FlightsSearchComponentCriteriaInput {
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
}

/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: Maybe<Scalars["String"]>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelectionInput>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}

/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: Maybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: Maybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: Maybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: Maybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: Maybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: Maybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: Maybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: Maybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: Maybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: Maybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}

export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = "CHILD_AGE_MISSING",
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = "DATE_BEFORE_PREVIOUS_DATE",
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = "DATE_NOT_IN_VALID_RANGE",
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = "DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE",
  /** Age of infant is missing */
  INFANT_AGE_MISSING = "INFANT_AGE_MISSING",
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = "INVALID_DATE_FORMAT",
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = "INVALID_TRAVELER_COUNT",
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = "LESS_THAN_MINIMUM_ADULT",
  /** Location must not be blank */
  LOCATION_EMPTY = "LOCATION_EMPTY",
  /** Origin and destination location must not be the same */
  LOCATION_SAME = "LOCATION_SAME",
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = "MAX_STAY_DURATION_ERROR",
  /** Origin and Destination city cannot be same */
  SAME_CITY = "SAME_CITY",
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = "SPECIAL_CHARACTER_NOT_ALLOWED",
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = "TOO_SHORT_AIRPORT_STRING",
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = "UNATTENDED_INFANT_IN_LAP",
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = "UNATTENDED_INFANT_IN_SEAT",
}

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>;
  airline?: Maybe<Scalars["String"]>;
  cabinClass: FlightsCabinClass;
}

/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  seatChoice: SeatChoiceType;
}

/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars["String"];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: Maybe<Scalars["String"]>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: Maybe<Array<SeatSegmentInput>>;
  /** Represents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars["String"]>;
}

/** Enum class to represent the seat type variant. */
export enum FlightsSeatMapSeatVariant {
  ACCESSIBLE = "ACCESSIBLE",
  AISLE = "AISLE",
  AVAILABLE = "AVAILABLE",
  COLUMN = "COLUMN",
  EXIT = "EXIT",
  GALLEY = "GALLEY",
  PREFERRED = "PREFERRED",
  RESTROOM = "RESTROOM",
  ROW = "ROW",
  SELECTED = "SELECTED",
  UNAVAILABLE = "UNAVAILABLE",
}

/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = "DECREASING",
  INCREASING = "INCREASING",
}

/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = "ARRIVAL",
  DEPARTURE = "DEPARTURE",
  DURATION = "DURATION",
  PRICE = "PRICE",
  RECOMMENDED = "RECOMMENDED",
}

/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = "EQUAL",
  GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL",
}

/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars["Int"];
  stopFilterOperation: FlightsStopFilterOperation;
}

/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = "AFTERNOON",
  EARLY_MORNING = "EARLY_MORNING",
  EVENING = "EVENING",
  MORNING = "MORNING",
}

/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}

/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars["Int"]>>;
  /** Traveler count */
  count: Scalars["Int"];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT_IN_LAP = "INFANT_IN_LAP",
  INFANT_IN_SEAT = "INFANT_IN_SEAT",
}

/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}

export enum FooterButtonType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = "HORIZONTAL_RULE",
}

/** Represents all the common information in the journey review block on FIS  */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = "ALL_JOURNEYS",
  CURRENT_JOUNRNEY = "CURRENT_JOUNRNEY",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum FunnelLocation {
  CHECKOUT = "CHECKOUT",
  CHECKOUT_ERROR = "CHECKOUT_ERROR",
  CONFIRMATION = "CONFIRMATION",
  DETAILS = "DETAILS",
  ENTRY = "ENTRY",
  FEATURES = "FEATURES",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  POST_BOOKING = "POST_BOOKING",
  SEARCH_RESULTS = "SEARCH_RESULTS",
  SYSTEM = "SYSTEM",
  USER = "USER",
}

/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = "AIRPORT",
  DESTINATION = "DESTINATION",
  PROPERTY = "PROPERTY",
}

/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = "ACTIVITY",
  CAR = "CAR",
  CRUISE = "CRUISE",
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
  PACKAGE = "PACKAGE",
  UNKNOWN = "UNKNOWN",
}

/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQlPairInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
}

/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = "FROM_AIRPORT",
  ROUNDTRIP = "ROUNDTRIP",
  TO_AIRPORT = "TO_AIRPORT",
}

export enum GroundTransfersGroupViewType {
  CARDS_LIST = "CARDS_LIST",
}

/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}

/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: Maybe<CoordinatesInput>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  type: GeoType;
}

export enum GroundTransfersMapTransitOption {
  BUS = "BUS",
  NONE = "NONE",
  TRAIN = "TRAIN",
}

export enum GroundTransfersMapTravelMode {
  DRIVING = "DRIVING",
  TRANSIT = "TRANSIT",
}

/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars["String"];
}

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

export enum GroundTransfersSectionStyle {
  BULLETED = "BULLETED",
  STANDARD = "STANDARD",
}

/** Text style to apply to text */
export enum GroundTransfersStyle {
  /** Bold styling */
  EMPHASISED = "EMPHASISED",
  /** Green text styling */
  POSITIVE = "POSITIVE",
  /** Regular text with no styling, default Value */
  STANDARD = "STANDARD",
}

/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars["Int"];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT = "INFANT",
}

/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = "END",
  START = "START",
}

/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = "PRIMARY",
  TERTIARY = "TERTIARY",
}

/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = "DEFAULT",
  MINIMAL = "MINIMAL",
  SIMPLIFIED = "SIMPLIFIED",
}

/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = "HORIZONTAL_RULE",
}

/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = "HEADING",
  SUBHEADING = "SUBHEADING",
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = "EXTRA_LARGE",
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}

export enum HistoryType {
  ACTIVITY_DETAIL = "ACTIVITY_DETAIL",
  ACTIVITY_SEARCH = "ACTIVITY_SEARCH",
  CAR_DETAIL = "CAR_DETAIL",
  CAR_SEARCH = "CAR_SEARCH",
  CRUISE_SEARCH = "CRUISE_SEARCH",
  FLIGHT_DETAIL = "FLIGHT_DETAIL",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  PACKAGE_SEARCH = "PACKAGE_SEARCH",
  PROPERTY_DETAIL = "PROPERTY_DETAIL",
  PROPERTY_SEARCH = "PROPERTY_SEARCH",
}

export interface HttpHeaderInput {
  name: Scalars["String"];
  values: Array<Scalars["String"]>;
}

export enum HttpStatus {
  ACCEPTED = "ACCEPTED",
  ALREADY_REPORTED = "ALREADY_REPORTED",
  BAD_GATEWAY = "BAD_GATEWAY",
  BAD_REQUEST = "BAD_REQUEST",
  BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
  CHECKPOINT = "CHECKPOINT",
  CONFLICT = "CONFLICT",
  CONTINUE = "CONTINUE",
  CREATED = "CREATED",
  DESTINATION_LOCKED = "DESTINATION_LOCKED",
  EXPECTATION_FAILED = "EXPECTATION_FAILED",
  FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
  FORBIDDEN = "FORBIDDEN",
  FOUND = "FOUND",
  GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
  GONE = "GONE",
  HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
  IM_USED = "IM_USED",
  INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
  INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
  LENGTH_REQUIRED = "LENGTH_REQUIRED",
  LOCKED = "LOCKED",
  LOOP_DETECTED = "LOOP_DETECTED",
  METHOD_FAILURE = "METHOD_FAILURE",
  METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
  MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
  MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
  MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
  MULTI_STATUS = "MULTI_STATUS",
  NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
  NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
  NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
  NOT_EXTENDED = "NOT_EXTENDED",
  NOT_FOUND = "NOT_FOUND",
  NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
  NOT_MODIFIED = "NOT_MODIFIED",
  NO_CONTENT = "NO_CONTENT",
  OK = "OK",
  PARTIAL_CONTENT = "PARTIAL_CONTENT",
  PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
  PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
  PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
  PRECONDITION_FAILED = "PRECONDITION_FAILED",
  PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
  PROCESSING = "PROCESSING",
  PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
  REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
  REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
  REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
  REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
  REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
  RESET_CONTENT = "RESET_CONTENT",
  SEE_OTHER = "SEE_OTHER",
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
  SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
  TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
  TOO_EARLY = "TOO_EARLY",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
  UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
  UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
  UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
  URI_TOO_LONG = "URI_TOO_LONG",
  USE_PROXY = "USE_PROXY",
  VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
}

/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = "EXTRA_SMALL",
  LARGE = "LARGE",
  MEDIUM = "MEDIUM",
  MEDIUM_LARGE = "MEDIUM_LARGE",
  SMALL = "SMALL",
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  DEFAULT = "default",
  EMPHASIS = "emphasis",
  NEGATIVE = "negative",
  POSITIVE = "positive",
}

/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: Maybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars["UUID"];
  /** The Expedia User ID */
  expUserId?: Maybe<Scalars["String"]>;
  /** The user TUID */
  tuid?: Maybe<Scalars["String"]>;
}

export enum IncentivesRichTextPartStyle {
  IMPORTANT = "IMPORTANT",
  STANDARD = "STANDARD",
}

/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: Maybe<Scalars["String"]>;
  /** Gaia region id of the location */
  regionId?: Maybe<Scalars["String"]>;
}

/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars["String"];
  /** Order Id of the booking */
  orderId: Scalars["String"];
  /** Trip Id of the booking */
  tripId: Scalars["String"];
}

export interface InsuranceBookingOverviewRequestInput {
  orderNumber?: Maybe<Scalars["String"]>;
  tripId: Scalars["String"];
}

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars["String"];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars["String"]>;
  /** Drop-off location for car */
  dropOffLocation?: Maybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: Maybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: Maybe<Array<Scalars["String"]>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars["String"];
  orderNumber: Scalars["String"];
}

export enum InsuranceListLayout {
  SINGLE_COLUMN = "SINGLE_COLUMN",
}

export enum InsuranceListType {
  ORDERED = "ORDERED",
  UNORDERED = "UNORDERED",
}

export enum InsuranceListTypeOld {
  ICON = "ICON",
  NUMBERED = "NUMBERED",
}

export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars["String"];
  /** Search term */
  searchTerm: Scalars["String"];
}

export enum InsuranceMessageType {
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

export enum InsuranceMutationStatus {
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export enum InsuranceMutationType {
  ADD_INSURANCE = "ADD_INSURANCE",
  REMOVE_INSURANCE = "REMOVE_INSURANCE",
}

export enum InsurancePhrasePartStyle {
  /** Green */
  COLOR_GREEN = "COLOR_GREEN",
  /** Red */
  COLOR_RED = "COLOR_RED",
  /** Italic styling */
  EMPHASIS = "EMPHASIS",
  /** Bold styling */
  IMPORTANT = "IMPORTANT",
  /** Represents no style or regular text */
  STANDARD = "STANDARD",
}

export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = "APPLY_REWARD_POINTS",
  DO_NOT_APPLY_REWARD_POINTS = "DO_NOT_APPLY_REWARD_POINTS",
}

export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: Maybe<Array<Scalars["String"]>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: Maybe<Scalars["String"]>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: Maybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: Maybe<Scalars["String"]>;
  /** TripId */
  tripId: Scalars["UUID"];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: Maybe<Scalars["String"]>;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: Maybe<Scalars["String"]>;
  offerTypeId?: Maybe<Scalars["Int"]>;
}

/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: Maybe<Scalars["String"]>;
  /** Name of interest */
  name?: Maybe<Scalars["String"]>;
}

/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = "AICTRAVELGROUP",
  AMOMA = "AMOMA",
  ANA = "ANA",
  BESTBUYHOTEL = "BESTBUYHOTEL",
  BONOTEL = "BONOTEL",
  CNTRAVEL = "CNTRAVEL",
  CTRIP = "CTRIP",
  DESPEGAR = "DESPEGAR",
  DIDATRAVEL = "DIDATRAVEL",
  DIRECT_AGENCY = "DIRECT_AGENCY",
  EUROPLAYAS = "EUROPLAYAS",
  EXCITEHOLIDAYS = "EXCITEHOLIDAYS",
  EZZEGO_1 = "EZZEGO_1",
  GETAROOM = "GETAROOM",
  HOME_AWAY = "HOME_AWAY",
  HOTELDOBESTDAYTRAVEL = "HOTELDOBESTDAYTRAVEL",
  HOTEL_BEDS = "HOTEL_BEDS",
  HRS = "HRS",
  JAC_TRAVEL = "JAC_TRAVEL",
  JAL = "JAL",
  JALAN = "JALAN",
  JTB = "JTB",
  JUMBOTOURS = "JUMBOTOURS",
  MAGICROOMS = "MAGICROOMS",
  MERCHANT = "MERCHANT",
  MGBEDBANK = "MGBEDBANK",
  MIKI = "MIKI",
  MTS = "MTS",
  NTA = "NTA",
  NUITEE = "NUITEE",
  OPAQUE = "OPAQUE",
  OSTROVOK = "OSTROVOK",
  PEGASUS = "PEGASUS",
  RAKUTEN = "RAKUTEN",
  RESTEL = "RESTEL",
  ROOMER = "ROOMER",
  SMYROOMS = "SMYROOMS",
  SUNHOTELS = "SUNHOTELS",
  THOMASCOOK_EUR = "THOMASCOOK_EUR",
  THOMASCOOK_UK = "THOMASCOOK_UK",
  TOURICO = "TOURICO",
  TRAVELLANDA = "TRAVELLANDA",
  TRAVELREPUBLIC = "TRAVELREPUBLIC",
  VENERE = "VENERE",
  VRBO = "VRBO",
  WELCOME_BEDS = "WELCOME_BEDS",
  WOORI = "WOORI",
  WORLDHOTELLINK = "WORLDHOTELLINK",
  WORLDSPAN = "WORLDSPAN",
  WOTIF = "WOTIF",
  YOUTRAVEL = "YOUTRAVEL",
  ZUMATA = "ZUMATA",
}

/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars["Int"];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars["String"];
}

export enum KeyPhrasesClientType {
  DEFAULT = "DEFAULT",
  FILTER = "FILTER",
  SNIPPET = "SNIPPET",
}

/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: Maybe<Array<Scalars["String"]>>;
  /** Maps to ReviewScoreRange */
  guestRating?: Maybe<Scalars["String"]>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: Maybe<Array<Scalars["String"]>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: Maybe<Array<Scalars["Int"]>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: Maybe<Scalars["String"]>;
  /** Maps to starList */
  stars?: Maybe<Scalars["String"]>;
  /** Maps to StructureType */
  structureTypes?: Maybe<Array<Scalars["String"]>>;
}

export enum LineOfBusiness {
  HOTEL = "HOTEL",
  INSURANCE = "INSURANCE",
}

/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = "ACTIVITIES",
  CAR = "CAR",
  CRUISES = "CRUISES",
  FLIGHT = "FLIGHT",
  GROUNDTRANSFERS = "GROUNDTRANSFERS",
  LODGING = "LODGING",
  PACKAGES = "PACKAGES",
  RAILS = "RAILS",
  UNCLASSIFIED = "UNCLASSIFIED",
}

/** ADs related property search options  */
export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = "ADS_ONLY",
}

/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = "CAR",
}

export enum LodgingFormMethod {
  GET = "GET",
  POST = "POST",
}

export enum LodgingInputType {
  EMAIL = "EMAIL",
  HIDDEN = "HIDDEN",
  PASSWORD = "PASSWORD",
  TEL = "TEL",
  TEXT = "TEXT",
  URL = "URL",
}

/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = "AGGRESSIVE",
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = "HIGHLIGHT",
  /** To be used for emphasis; typically bold. */
  STRONG = "STRONG",
}

/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = "AIRPORT",
  CIRCLE = "CIRCLE",
  HOTEL = "HOTEL",
  LANDMARK = "LANDMARK",
  METRO = "METRO",
  RESTAURANT = "RESTAURANT",
  SOLD_OUT = "SOLD_OUT",
  TRAIN = "TRAIN",
}

/** The type of map marker */
export enum MarkerType {
  HOTEL = "HOTEL",
  POI = "POI",
}

/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = "HTML",
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FULL_BOARD = "FULL_BOARD",
  HALF_BOARD = "HALF_BOARD",
}

export enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = "LOYALTY_HIGH_TIER",
  LOYALTY_LOW_TIER = "LOYALTY_LOW_TIER",
  LOYALTY_MIDDLE_TIER = "LOYALTY_MIDDLE_TIER",
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = "ADDON",
  COMPRESSION = "COMPRESSION",
  COUPON = "COUPON",
  DOUBLE_POINTS = "DOUBLE_POINTS",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  FREE_LX = "FREE_LX",
  HOTRATE = "HOTRATE",
  LEGAL = "LEGAL",
  LOGIN = "LOGIN",
  LOYALTY = "LOYALTY",
  NO_CC = "NO_CC",
  OVERFILTERED = "OVERFILTERED",
  PARTNER_LINKOFF = "PARTNER_LINKOFF",
  VACATION_RENTALS = "VACATION_RENTALS",
}

/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

/** The type of button to display */
export enum MishopUiDialogButtonType {
  PRIMARY = "PRIMARY",
  TERTIARY = "TERTIARY",
}

/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUiPlacardNotificationInput {
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: Maybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUiPlacardType {
  PRICE_CHANGE = "PRICE_CHANGE",
}

/** Contains necessary data for fetching property content */
export interface MishopUiPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: Maybe<Scalars["String"]>;
  relativeChangePropertyLink: Scalars["String"];
  relativeChangeRoomLink: Scalars["String"];
}

/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: Scalars["Float"];
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: Maybe<Scalars["String"]>;
}

/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = "APRIL",
  AUGUST = "AUGUST",
  DECEMBER = "DECEMBER",
  FEBRUARY = "FEBRUARY",
  JANUARY = "JANUARY",
  JULY = "JULY",
  JUNE = "JUNE",
  MARCH = "MARCH",
  MAY = "MAY",
  NOVEMBER = "NOVEMBER",
  OCTOBER = "OCTOBER",
  SEPTEMBER = "SEPTEMBER",
}

/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars["String"];
  /** The package type for this search */
  packageType: PackageType;
}

/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: Maybe<Array<ActivityNaturalKeyInput>>;
  cars?: Maybe<Array<CarNaturalKeyInput>>;
  flights?: Maybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: Maybe<Array<ActivityNaturalKeyInput>>;
  properties?: Maybe<Array<PropertyNaturalKeyInput>>;
}

/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: Maybe<Array<CarSearchCriteriaInput>>;
  flights?: Maybe<Array<FlightSearchCriteriaInput>>;
  properties?: Maybe<Array<PropertySearchCriteriaInput>>;
}

/** Enum class to represent the type of no cancel fee */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = "NO_CANCEL_FEE",
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = "NO_CHANGE_FEE",
}

/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  /** Type of primary button */
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  /** Type of secondary button */
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  /** Type of tertiary button */
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = "NEW_TAB",
  SAME_TAB = "SAME_TAB",
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = "ANCHOR",
  APP_DOWNLOAD_LINK = "APP_DOWNLOAD_LINK",
  BUTTON = "BUTTON",
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

export enum NotificationLocation {
  AFTER_HEADER = "AFTER_HEADER",
  AFTER_WIZARD = "AFTER_WIZARD",
  FOOTER = "FOOTER",
  IN_PAGE = "IN_PAGE",
  IN_PAGE_AD = "IN_PAGE_AD",
  LEGAL = "LEGAL",
  POPUP = "POPUP",
  PRE_HEADER = "PRE_HEADER",
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = "AFTER_HEADER",
  AFTER_WIZARD = "AFTER_WIZARD",
  FOOTER = "FOOTER",
  IN_PAGE = "IN_PAGE",
  IN_PAGE_AD = "IN_PAGE_AD",
  LEGAL = "LEGAL",
  POPUP = "POPUP",
  PRE_HEADER = "PRE_HEADER",
}

/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = "FORM",
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = "PAGE",
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = "ERROR",
  /** Type of success for the message */
  SUCCESS = "SUCCESS",
  /** Type of warning for the message */
  WARNING = "WARNING",
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = "INVALID_INPUT",
  /** SERVICE_ERROR message */
  SERVICE_ERROR = "SERVICE_ERROR",
  /** SUCCESS message */
  SUCCESS = "SUCCESS",
}

/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars["String"]>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars["URL"]>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars["String"]>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars["String"]>;
  /** property id */
  propertyId?: Maybe<Scalars["String"]>;
  /** regionId number */
  regionId?: Maybe<Scalars["String"]>;
}

/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = "FLOATING_ACTION_BUTTON",
  PRIMARY_BUTTON = "PRIMARY_BUTTON",
  SECONDARY_BUTTON = "SECONDARY_BUTTON",
  TERTIARY_BUTTON = "TERTIARY_BUTTON",
}

/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = "EMPHASIS",
  /** Bold styling */
  IMPORTANT = "IMPORTANT",
  /** Represents no style or regular text */
  STANDARD = "STANDARD",
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: Maybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars["Boolean"]>;
}

export enum NotificationType {
  APP_DOWNLOAD = "APP_DOWNLOAD",
  APP_HERO = "APP_HERO",
  CITI_COBRAND = "CITI_COBRAND",
  CITI_COBRAND_VERTICAL = "CITI_COBRAND_VERTICAL",
  GDPR = "GDPR",
  GENERIC = "GENERIC",
  MAD_MARQUEE = "MAD_MARQUEE",
  NONE = "NONE",
  OSANO = "OSANO",
  TRAVEL_ADVISORY = "TRAVEL_ADVISORY",
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars["String"];
  /** Represents the value of customer notification user input */
  value: Scalars["String"];
}

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars["String"];
  value: Scalars["Int"];
}

export enum OfferAttributeType {
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CC_REQUIRED = "NO_CC_REQUIRED",
  PAYMENT_CHOICE = "PAYMENT_CHOICE",
  VIP = "VIP",
}

/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: Maybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: Maybe<DateTimeInput>;
}

export interface PackageLocationInput {
  airportCode: Scalars["String"];
}

/** Checkout option and its value to apply on the checkoutUrl */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

export enum PackageSort {
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  RECOMMENDED = "RECOMMENDED",
}

export enum PackageType {
  FLIGHT_CAR = "FLIGHT_CAR",
  FLIGHT_HOTEL = "FLIGHT_HOTEL",
  FLIGHT_HOTEL_CAR = "FLIGHT_HOTEL_CAR",
  HOTEL_CAR = "HOTEL_CAR",
}

/** Page identity */
export enum PageLocation {
  /** All checkout related pages */
  CHECKOUT = "CHECKOUT",
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = "CHECKOUT_ERROR",
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = "CONFIRMATION",
  /** All product detail pages are identified as DETAILS */
  DETAILS = "DETAILS",
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = "ENTRY",
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = "FEATURES",
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = "PAYMENT_ERROR",
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = "POST_BOOKING",
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = "SEARCH_RESULTS",
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = "SYSTEM",
  /** User pages including sign-in, my account and rewards */
  USER = "USER",
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: Maybe<Scalars["Int"]>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: Maybe<Scalars["Int"]>;
}

export enum PayWithPointsUpdateAction {
  APPLY = "APPLY",
  REMOVE = "REMOVE",
}

/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Points information which will be used to pay for the booking */
  paymentPoints?: Maybe<PaymentPointsInput>;
  /** Payment token information which will be used to pay for the booking */
  paymentToken?: Maybe<PaymentTokenInput>;
  /** Type of the payment element */
  paymentType: PaymentMethodType;
}

export enum PaymentMethodType {
  CLICK_TO_PAY = "CLICK_TO_PAY",
  CREDIT_CARD = "CREDIT_CARD",
  MASTERPASS = "MASTERPASS",
  PAYPAL = "PAYPAL",
  POINTS = "POINTS",
}

export enum PaymentOptionType {
  CLICK_TO_PAY = "CLICK_TO_PAY",
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
  POINTS = "POINTS",
  STORED_CARD = "STORED_CARD",
}

export interface PaymentPointsInput {
  /** Payment instrument id for pay with points */
  instrumentId?: Maybe<Scalars["String"]>;
  /** Payment sub method for pay with points */
  paymentSubmethod: Scalars["String"];
  /** Whether points is used or not */
  usePoints: Scalars["Boolean"];
}

export interface PaymentSessionCriteriaInput {
  /** Booking info which controls what kind of payment sessions may be required for payment */
  bookingProductInfoDetails: Array<BookingProductDetailsInput>;
  /** Currency of the payment session */
  currency?: Maybe<CurrencyInput>;
  /** Payment token that represents the payment details */
  edgeToken: Scalars["String"];
  /** Browser metadata to set up 3DS */
  encodedBrowserMetadata: Scalars["String"];
  /** Trip ID to associate with the payment session */
  tripId: Scalars["UUID"];
  /** Version of the library to use for challenge */
  version: Scalars["String"];
}

export interface PaymentTokenInput {
  /** Payment session id for only 3DS booking */
  paymentSessionId?: Maybe<Scalars["String"]>;
  /** When provided, will store the payment method for future use */
  saveAs?: Maybe<Scalars["String"]>;
  /** Edge Token used for the payment */
  token: Scalars["String"];
  /** Type of payment being processed by the edge token */
  type: PaymentTokenType;
}

export enum PaymentTokenType {
  CREDIT_CARD = "CREDIT_CARD",
  STORED_CARD = "STORED_CARD",
}

export enum PaymentType {
  COUPON_ELIGIBLE = "COUPON_ELIGIBLE",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_WITHOUT_CREDITCARD = "PAY_WITHOUT_CREDITCARD",
}

/** Enum representing the size options for the UITK PaymentType element */
export enum PaymentTypeLogoSize {
  LARGE = "LARGE",
  SMALL = "SMALL",
}

export enum PenaltyCollectionType {
  ONLINE_PENALTY_COLLECTION = "ONLINE_PENALTY_COLLECTION",
}

/** Name of the main traveler */
export interface PersonNameInput {
  firstName: Scalars["String"];
  lastName: Scalars["String"];
}

/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: Scalars["String"];
  /** The ISO country code (e.g. 'USA', 'GBR', etc) */
  phoneCountryId: Scalars["String"];
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = "GLOBAL_NAV_BUTTON",
  GLOBAL_NAV_LINK = "GLOBAL_NAV_LINK",
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = "MENU_ITEM",
  NAV_LINK = "NAV_LINK",
}

/** Points related property search options  */
export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = "SHOP_WITHOUT_POINTS",
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

/** Points Input needed to update points */
export interface PointsInput {
  /** Actions that points can undertake, e.g. Apply/Remove */
  action: PayWithPointsUpdateAction;
  /** Unique identifier for the Trip */
  tripId: Scalars["UUID"];
}

/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = "ALTERNATIVE_ACTION_ON_FAILURE",
}

export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars["Boolean"];
}

/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: Maybe<Scalars["Float"]>;
  /** The minimum price, e.g. 50.00 */
  min?: Maybe<Scalars["Float"]>;
}

export enum PricingSchemeType {
  DAILY_RATE = "DAILY_RATE",
  TOTAL_RATE = "TOTAL_RATE",
}

/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: Maybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}

/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: Maybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  selectedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: Maybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}

export interface PrimaryPackageSearchCriteriaInput {
  /** If not provided, packages returned will be for differrent duration and popular advance purchase window based on the themes */
  dateRange?: Maybe<DateRangeInput>;
  /** If not provided, packages returned will be for differrent destination popular based on the themes */
  destination?: Maybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: Maybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: Maybe<Array<TravelerOccupancyGroupInput>>;
}

/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: Maybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  rooms: Array<RoomInput>;
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = "CAN_NOT_TRACK",
  CAN_TRACK = "CAN_TRACK",
}

/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: Maybe<Scalars["String"]>;
}

export enum ProductQuestionTopic {
  HOTEL = "HOTEL",
}

export enum ProductType {
  ARTICLE = "ARTICLE",
  CAR_DETAILS = "CAR_DETAILS",
  DESTINATION = "DESTINATION",
  DESTINATION_EXPERIENCE = "DESTINATION_EXPERIENCE",
  EXPERIENCE = "EXPERIENCE",
  EXPERT_TIP = "EXPERT_TIP",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  LX_DETAILS = "LX_DETAILS",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POI_GAIA = "POI_GAIA",
  PROPERTY_DETAILS = "PROPERTY_DETAILS",
}

export enum ProfileLayoutDirection {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}

/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  PARKING = "PARKING",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WATERSLIDE = "WATERSLIDE",
}

export enum PropertyAmenityType {
  ACCESSIBILITY = "ACCESSIBILITY",
  BATHROOM = "BATHROOM",
  BEDROOM = "BEDROOM",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CONVENIENCES = "CONVENIENCES",
  ENTERTAINMENT = "ENTERTAINMENT",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FOOD_DRINK = "FOOD_DRINK",
  GUEST_SERVICES = "GUEST_SERVICES",
  INTERNET = "INTERNET",
  MORE = "MORE",
  OUTDOOR = "OUTDOOR",
  OUTDOOR_SPACE = "OUTDOOR_SPACE",
  PARKING = "PARKING",
  PROPERTY = "PROPERTY",
  ROOM = "ROOM",
  SPA = "SPA",
  THINGS_TO_DO = "THINGS_TO_DO",
}

export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = "NEGATIVE",
  /** Positive price trend */
  POSITIVE = "POSITIVE",
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = "NON_REFUNDABLE",
  REFUNDABLE_WITH_NO_PENALTY = "REFUNDABLE_WITH_NO_PENALTY",
  REFUNDABLE_WITH_PENALTY = "REFUNDABLE_WITH_PENALTY",
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}

export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = "HOTEL",
  VACATION_RENTAL = "VACATION_RENTAL",
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = "ACCESSIBLE_BATHROOM",
  ELEVATOR = "ELEVATOR",
  IN_ROOM_ACCESSIBLE = "IN_ROOM_ACCESSIBLE",
  ROLL_IN_SHOWER = "ROLL_IN_SHOWER",
  SERVICE_ANIMAL = "SERVICE_ANIMAL",
  SIGN_LANGUAGE_INTERPRETER = "SIGN_LANGUAGE_INTERPRETER",
  STAIR_FREE_PATH = "STAIR_FREE_PATH",
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  BEACH = "BEACH",
  CASINO = "CASINO",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  GOLF = "GOLF",
  HOT_SPRING = "HOT_SPRING",
  HOT_TUB = "HOT_TUB",
  KITCHEN_KITCHEN = "KITCHEN_KITCHEN",
  KITCHEN_KITCHENETTE = "KITCHEN_KITCHENETTE",
  OCEAN_VIEW = "OCEAN_VIEW",
  PETS = "PETS",
  POOL = "POOL",
  SPA_ON_SITE = "SPA_ON_SITE",
  WASHER_DRYER = "WASHER_DRYER",
  WATER_PARK = "WATER_PARK",
  WIFI = "WIFI",
}

/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: Maybe<Scalars["String"]>;
  /** Meta afflid channel code */
  afflid?: Maybe<Scalars["String"]>;
  /** Meta afmcid channel code */
  afmcid?: Maybe<Scalars["String"]>;
  /** Meta brandcid channel code */
  brandcid?: Maybe<Scalars["String"]>;
  /** Meta emlcid channel code */
  emlcid?: Maybe<Scalars["String"]>;
  /** Meta emldtl channel code */
  emldtl?: Maybe<Scalars["String"]>;
  /** Meta gclid channel code */
  gclid?: Maybe<Scalars["String"]>;
  /** Meta icmcid channel code */
  icmcid?: Maybe<Scalars["String"]>;
  /** Meta icmdtl channel code */
  icmdtl?: Maybe<Scalars["String"]>;
  /** Meta k_user_id channel code */
  k_user_id?: Maybe<Scalars["String"]>;
  /** Meta kword channel code */
  kword?: Maybe<Scalars["String"]>;
  /** Meta lnkloc channel code */
  lnkloc?: Maybe<Scalars["String"]>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: Maybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: Maybe<Array<PropertyMarketingTagInput>>;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: Maybe<Scalars["Int"]>;
  /** Meta mdpcid channel code */
  mdpcid?: Maybe<Scalars["String"]>;
  /** Meta mdpdtl channel code */
  mdpdtl?: Maybe<Scalars["String"]>;
  /** Meta olacid channel code */
  olacid?: Maybe<Scalars["String"]>;
  /** Meta oladtl channel code */
  oladtl?: Maybe<Scalars["String"]>;
  /** Meta semcid channel code */
  semcid?: Maybe<Scalars["String"]>;
  /** Meta semdtl channel code */
  semdtl?: Maybe<Scalars["String"]>;
  /** Meta seocid channel code */
  seocid?: Maybe<Scalars["String"]>;
}

/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars["String"];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars["Boolean"]>;
  ratePlanId: Scalars["String"];
  ratePlanType?: Maybe<Scalars["String"]>;
  roomTypeId: Scalars["String"];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: Maybe<ShoppingPathType>;
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars["Int"];
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = "ARTIFICIALLY_FENCED_RATE",
  MIXED_RATE_PLAN = "MIXED_RATE_PLAN",
  NO_CREDIT_CARD = "NO_CREDIT_CARD",
}

export enum PropertyPaymentModel {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW",
}

/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW",
}

/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: Maybe<Array<Scalars["String"]>>;
  /** The user's requested bed type */
  bedType?: Maybe<Scalars["String"]>;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: Maybe<Scalars["Boolean"]>;
  /** Free text special request to be conveyed to the property */
  specialRequests?: Maybe<Scalars["String"]>;
}

/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = "BUSINESS_TRAVELERS",
  COUPLES = "COUPLES",
  EVERYONE = "EVERYONE",
  FAMILIES = "FAMILIES",
  GETAWAY_WITH_FRIENDS = "GETAWAY_WITH_FRIENDS",
  GOLF = "GOLF",
  OTHER = "OTHER",
  OVERNIGHT_STAY = "OVERNIGHT_STAY",
  PERSONAL_EVENT = "PERSONAL_EVENT",
  SHOPPING = "SHOPPING",
  SPA = "SPA",
  STUDENTS = "STUDENTS",
}

/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: Maybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: Maybe<Scalars["Boolean"]>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: Maybe<Scalars["Boolean"]>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: Maybe<Scalars["String"]>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Maybe<Scalars["Locale"]>;
  /** Filter review results by a list of review ratings */
  ratings?: Maybe<Array<Scalars["Float"]>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: Maybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: Maybe<Scalars["Int"]>;
  /** Filter review results by user provided keyword */
  searchTerm?: Maybe<Scalars["String"]>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: Maybe<Array<Scalars["String"]>>;
  /** Filter review results by travel companions */
  travelCompanion?: Maybe<Array<Scalars["String"]>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: Maybe<Array<Scalars["String"]>>;
  /** Filter review results by trip reasons */
  tripReason?: Maybe<Array<Scalars["String"]>>;
}

/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  NEWEST_TO_OLDEST_BY_LANGUAGE = "NEWEST_TO_OLDEST_BY_LANGUAGE",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST",
  OLDEST_TO_NEWEST_BY_LANGUAGE = "OLDEST_TO_NEWEST_BY_LANGUAGE",
}

/** [Optional] Review filter type */
export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = "CRITICAL",
  /** filter reviews by rating >= 3 */
  POSITIVE = "POSITIVE",
  /** filter reviews by latest date */
  RECENT = "RECENT",
}

/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
}

/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: Maybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: Maybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: Maybe<Array<Scalars["Int"]>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: Maybe<Scalars["String"]>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: Maybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: Maybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: Maybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: Maybe<Scalars["String"]>;
  /** Filter results by the payment type. */
  paymentType?: Maybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: Maybe<Scalars["String"]>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: Maybe<PriceRangeInput>;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: Maybe<Array<Scalars["Int"]>>;
  /** Filter results by user provided string */
  propertyName?: Maybe<Scalars["String"]>;
  /** Property syle filters */
  propertyStyles?: Maybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: Maybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: Maybe<Array<Scalars["String"]>>;
  /** Filter results by availability */
  showAvailableOnly?: Maybe<Scalars["Boolean"]>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: Maybe<Array<Scalars["Float"]>>;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: Maybe<StarRangeInput>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: Maybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: Maybe<Scalars["String"]>;
  /** Filter results by the type of traveler. */
  travelerType?: Maybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: Maybe<Scalars["Boolean"]>;
}

export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  ADS_ONLY = "ADS_ONLY",
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS",
}

export enum PropertySectionRef {
  PRICE_DISPLAY_SERVICE_RESPONSE = "PRICE_DISPLAY_SERVICE_RESPONSE",
  RECOMMENDED_OFFER = "RECOMMENDED_OFFER",
  ROOMS_AND_RATES = "ROOMS_AND_RATES",
}

/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Maybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: Maybe<Scalars["String"]>;
  /** Points related property search option */
  points?: Maybe<Points>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = "AARP_MEMBER_DISCOUNT",
  BEST_DEAL = "BEST_DEAL",
  DISTANCE = "DISTANCE",
  MEMBER_PRICING = "MEMBER_PRICING",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  PRICE_RELEVANT = "PRICE_RELEVANT",
  PROPERTY_CLASS = "PROPERTY_CLASS",
  PROPERTY_NAME = "PROPERTY_NAME",
  RECOMMENDED = "RECOMMENDED",
  REVIEW = "REVIEW",
  VACATION_RENTAL = "VACATION_RENTAL",
}

export enum PropertyStyle {
  BOUTIQUE = "BOUTIQUE",
  HOMES = "HOMES",
  HOTELS = "HOTELS",
  LGBT = "LGBT",
  LUXURY = "LUXURY",
  OUTDOOR = "OUTDOOR",
  UNIQUE = "UNIQUE",
}

/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: Maybe<Scalars["String"]>;
  candidateHmGuid?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  rank?: Maybe<Scalars["String"]>;
  slots?: Maybe<Scalars["String"]>;
  testVersionOverride?: Maybe<Scalars["String"]>;
  trackingData: Scalars["String"];
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST",
}

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars["String"];
  max: Scalars["Int"];
  min: Scalars["Int"];
}

export enum RateDiscountType {
  MEMBER_DEAL = "MEMBER_DEAL",
  MOBILE_EXCLUSIVE = "MOBILE_EXCLUSIVE",
  REGULAR = "REGULAR",
  TONIGHT_ONLY = "TONIGHT_ONLY",
}

export enum RecommendedType {
  BESPOKE = "BESPOKE",
  DESTINATIONS = "DESTINATIONS",
  OFFERS = "OFFERS",
}

/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = "ADDRESS",
  AIRPORT = "AIRPORT",
  CITY = "CITY",
  CONTINENT = "CONTINENT",
  COUNTRY = "COUNTRY",
  HIGH_LEVEL_REGION = "HIGH_LEVEL_REGION",
  METRO_STATION = "METRO_STATION",
  MULTI_CITY_VICINITY = "MULTI_CITY_VICINITY",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POINT_OF_INTEREST = "POINT_OF_INTEREST",
  PROVINCE_STATE = "PROVINCE_STATE",
  TRAIN_STATION = "TRAIN_STATION",
  UNKNOWN = "UNKNOWN",
}

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars["String"]>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars["String"];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars["String"];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars["String"];
  offerTypeId?: Maybe<Scalars["Int"]>;
}

/** Tags Associated with the response */
export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = "CACHE_SOURCE_AIRBLAZE",
  CACHE_SOURCE_BYOT_AIRBLAZE = "CACHE_SOURCE_BYOT_AIRBLAZE",
  LISTINGS_PAGINATED = "LISTINGS_PAGINATED",
  LISTINGS_PAGINATED_SLICED = "LISTINGS_PAGINATED_SLICED",
  LISTING_CACHE_SOURCE = "LISTING_CACHE_SOURCE",
  LISTING_DOWNLEVEL_SOURCE = "LISTING_DOWNLEVEL_SOURCE",
  RESPONSE_SUMMARY_CACHED_CONFIG = "RESPONSE_SUMMARY_CACHED_CONFIG",
  RESPONSE_SUMMARY_CACHED_ML = "RESPONSE_SUMMARY_CACHED_ML",
  RESPONSE_SUMMARY_HYBRID = "RESPONSE_SUMMARY_HYBRID",
  RESPONSE_SUMMARY_LIVE = "RESPONSE_SUMMARY_LIVE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Result {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface ResumeBookingInput {
  /** Order number of the booking for resuming */
  orderNumber: Scalars["String"];
  /** List of payment options used for the booking */
  paymentOptionsUsed: Array<PaymentOptionType>;
  /** Unique identifier of the collection of products / trip */
  tripId: Scalars["UUID"];
}

/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = "HELPFUL_REVIEW",
  REVIEW_REPORT_FLAG = "REVIEW_REPORT_FLAG",
}

/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: Maybe<Scalars["Float"]>;
  /** The minimum review score, e.g. 1.0 */
  min?: Maybe<Scalars["Float"]>;
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = "APPLY_REWARD_POINTS",
  DO_NOT_APPLY_REWARD_POINTS = "DO_NOT_APPLY_REWARD_POINTS",
}

/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars["Int"];
  /** The number of children in the room */
  children?: Maybe<Array<ChildInput>>;
}

export enum RouteType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}

/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = "SEVEN_DAYS",
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = "THREE_DAYS",
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = "METRO_CITY",
}

/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars["String"];
  /** Search item regionId. */
  regionId: Scalars["String"];
  /** Search item region type. */
  regionType?: Maybe<Scalars["String"]>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars["String"];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: Maybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: Maybe<SearchHistoryDestinationType>;
}

/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: Maybe<Array<InterestInput>>;
  /** SEM param, fetch from URL */
  semDtl?: Maybe<Scalars["String"]>;
  /** SEM param, fetch from URL */
  semdtl?: Maybe<Scalars["String"]>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: Maybe<Scalars["String"]>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: Maybe<Scalars["String"]>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: Maybe<SearchOfferPriceInput>;
  ratePlanId?: Maybe<Scalars["String"]>;
  roomTypeId?: Maybe<Scalars["String"]>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: Maybe<Scalars["String"]>;
  /** The total price of the search offer */
  price?: Maybe<MoneyInput>;
}

/** Enum class to represent the type of seat choice */
export enum SeatChoiceType {
  SEAT_CHOICE = "SEAT_CHOICE",
}

/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars["String"];
  /** This will be used for unique identification of segment */
  identifier: Scalars["String"];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars["String"];
}

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars["String"];
  value: Scalars["String"];
}

export enum Severity {
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}

/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: Maybe<MultiItemContextInput>;
}

/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = "ATTACH",
  PACKAGE = "PACKAGE",
  STANDALONE = "STANDALONE",
}

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: Maybe<Array<BooleanValueInput>>;
  counts?: Maybe<Array<NumberValueInput>>;
  dates?: Maybe<Array<DateValueInput>>;
  ranges?: Maybe<Array<RangeValueInput>>;
  selections?: Maybe<Array<SelectedValueInput>>;
}

/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = "CLEAR_DATA",
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = "CLOSE_AND_APPLY",
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = "CLOSE_AND_DO_NOT_APPLY",
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = "OPEN_MODAL",
}

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars["String"];
}

/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars["Int"]>;
}

/** Enum to describe the initial state of a collapsible section. */
export enum SmartFormCollapsibleSectionState {
  COLLAPSED = "COLLAPSED",
  OPEN = "OPEN",
}

export interface SmartFormDataInput {
  containerCategory: Scalars["String"];
  timestamp: Scalars["String"];
  userInput: SmartFormUserInput;
}

/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  NUMERIC = "NUMERIC",
  TEXT = "TEXT",
}

export interface SmartFormUserFieldInput {
  inputId: Scalars["String"];
  value: Scalars["String"];
}

export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}

export enum SourceType {
  ESR = "ESR",
  GDS = "GDS",
}

/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = "ADDITIONAL_DRIVER",
  BICYCLE_RACK = "BICYCLE_RACK",
  BOOSTER_SEAT = "BOOSTER_SEAT",
  INFANT_SEAT = "INFANT_SEAT",
  LEFT_HAND_CONTROL = "LEFT_HAND_CONTROL",
  LUGGAGE_RACK = "LUGGAGE_RACK",
  NAV_SYSTEM = "NAV_SYSTEM",
  RIGHT_HAND_CONTROL = "RIGHT_HAND_CONTROL",
  ROAD_CONGESTION_PAYMENT_SCHEME = "ROAD_CONGESTION_PAYMENT_SCHEME",
  SATELLITE_RADIO = "SATELLITE_RADIO",
  SKI_RACK = "SKI_RACK",
  SNOW_CHAINS = "SNOW_CHAINS",
  SNOW_TIRES = "SNOW_TIRES",
  TODDLER_SEAT = "TODDLER_SEAT",
  TOLL_PAYMENT_TAG_PASS = "TOLL_PAYMENT_TAG_PASS",
  TRAILER_HITCH = "TRAILER_HITCH",
  WIFI_ACCESS = "WIFI_ACCESS",
  WINTER_PACKAGE = "WINTER_PACKAGE",
}

/** Element types - button, link etc. */
export enum SponsoredContentElementType {
  /** Button element */
  BUTTON = "BUTTON",
  /** Hyperlink element */
  LINK = "LINK",
}

/** Input model to hold input params for queries.This includes target params which are not a part of ContextInput, and uuid. */
export interface SponsoredContentTargetInput {
  /** Domain of the page requesting the ad, required for v2 targeting */
  domain?: Maybe<Scalars["String"]>;
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars["String"];
  /** Optional as siteId in context is usually in most cases for BEX. However, it serves asan override for sites where the siteId is not numeric. Eg. HCOM, HCOM_UK etc. */
  siteId?: Maybe<Scalars["String"]>;
  /** Target variant. Eg. pwa */
  variant?: Maybe<Scalars["String"]>;
}

export interface StarRangeInput {
  max?: Maybe<Scalars["Float"]>;
  min?: Maybe<Scalars["Float"]>;
}

export enum StrikeOutType {
  ATTACH = "ATTACH",
  INVALID = "INVALID",
  LOYALTY = "LOYALTY",
  PACKAGE = "PACKAGE",
  PRICE_SURVEY = "PRICE_SURVEY",
  STANDALONE = "STANDALONE",
}

export enum StructureType {
  AGRITOURISM = "AGRITOURISM",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  APARTMENT = "APARTMENT",
  APART_HOTEL = "APART_HOTEL",
  BED_AND_BREAKFAST = "BED_AND_BREAKFAST",
  CABIN = "CABIN",
  CAPSULE_HOTEL = "CAPSULE_HOTEL",
  CARAVAN_PARK = "CARAVAN_PARK",
  CASTLE = "CASTLE",
  CHALET = "CHALET",
  CONDO = "CONDO",
  CONDO_RESORT = "CONDO_RESORT",
  COTTAGE = "COTTAGE",
  COUNTRY_HOUSE = "COUNTRY_HOUSE",
  CRUISE = "CRUISE",
  ECO_HOTEL = "ECO_HOTEL",
  GUEST_HOUSE = "GUEST_HOUSE",
  HOLIDAY_PARK = "HOLIDAY_PARK",
  HOSTAL = "HOSTAL",
  HOSTEL = "HOSTEL",
  HOTEL = "HOTEL",
  HOTEL_RESORT = "HOTEL_RESORT",
  HOUSE_BOAT = "HOUSE_BOAT",
  INN = "INN",
  LODGE = "LODGE",
  LONGHOUSE = "LONGHOUSE",
  MOTEL = "MOTEL",
  OVERWATER = "OVERWATER",
  PALACE = "PALACE",
  PENSION = "PENSION",
  POUSADA_BRAZIL = "POUSADA_BRAZIL",
  POUSADA_PORTUGAL = "POUSADA_PORTUGAL",
  RANCH = "RANCH",
  RESIDENCE = "RESIDENCE",
  RIAD = "RIAD",
  RYOKAN = "RYOKAN",
  SAFARI = "SAFARI",
  SERVICED_APARTMENT = "SERVICED_APARTMENT",
  TOWNHOUSE = "TOWNHOUSE",
  TRADITIONAL_BUILDING = "TRADITIONAL_BUILDING",
  TREE_HOUSE = "TREE_HOUSE",
  UNKNOWN = "UNKNOWN",
  VACATION_HOME = "VACATION_HOME",
  VILLA = "VILLA",
  VIP = "VIP",
}

/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = "LTR",
  RTL = "RTL",
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = "BOLD",
  MEDIUM = "MEDIUM",
  REGULAR = "REGULAR",
}

export enum Theme {
  BRAND = "BRAND",
  BRANDED_DEAL = "BRANDED_DEAL",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO = "INFO",
  LINK = "LINK",
  LOYALTY = "LOYALTY",
  LOYALTY_HIGH_TIER = "LOYALTY_HIGH_TIER",
  LOYALTY_LOW_TIER = "LOYALTY_LOW_TIER",
  LOYALTY_MIDDLE_TIER = "LOYALTY_MIDDLE_TIER",
  NOTIFICATION = "NOTIFICATION",
  SAVED = "SAVED",
  SPONSORED = "SPONSORED",
  SUCCESS = "SUCCESS",
  SUCCESS_MEDIUM = "SUCCESS_MEDIUM",
  SUPPLIER_PROMO = "SUPPLIER_PROMO",
  URGENT = "URGENT",
  VIEWED = "VIEWED",
  VIP = "VIP",
  VIP_ACCESS = "VIP_ACCESS",
}

export enum ThreeDSv2InventoryType {
  LOCAL_INVENTORY = "LOCAL_INVENTORY",
}

export enum TransportationSearchActionTypes {
  CLOSE_DIALOG = "CLOSE_DIALOG",
  OPEN_DIALOG = "OPEN_DIALOG",
  REDIRECT = "REDIRECT",
  RETRY = "RETRY",
}

export enum TransportationSearchDialogsId {
  WORKING_ON_IT = "WORKING_ON_IT",
}

/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}

/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: Maybe<Scalars["Int"]>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT_IN_LAP = "INFANT_IN_LAP",
  INFANT_IN_SEAT = "INFANT_IN_SEAT",
}

export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}

export enum TravelerType {
  BUSINESS = "BUSINESS",
  FAMILY = "FAMILY",
  LGBT = "LGBT",
  ROMANTIC = "ROMANTIC",
}

export enum TripCareButtonAction {
  BACK = "BACK",
  RELOAD = "RELOAD",
}

export enum TripCareListType {
  BULLET = "BULLET",
  NO_BULLET = "NO_BULLET",
  NUMBERED = "NUMBERED",
}

export enum TripCarePhraseStyle {
  BOLD = "BOLD",
  SMALL = "SMALL",
}

export enum TripCarePhraseType {
  BUTTON = "BUTTON",
  TEXT = "TEXT",
}

export enum TripIntentPersonType {
  ADULT = "ADULT",
  CHILD = "CHILD",
}

/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: Maybe<Scalars["String"]>;
  tripItemId: Scalars["String"];
  tripViewId: Scalars["String"];
}

/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: Maybe<Scalars["String"]>;
  tripViewId: Scalars["String"];
}

export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = "MATCH_PARENT_CONTAINER",
  WRAP_CONTENT = "WRAP_CONTENT",
}

export enum TripsContentType {
  PDF = "PDF",
}

/** Display theme for TripsContentUnorderedList */
export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = "BULLETS",
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = "NO_BULLETS",
}

/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars["String"];
}

/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = "BARCODE",
  E_FRANKING_STAMP = "E_FRANKING_STAMP",
  QR_CODE = "QR_CODE",
}

export enum TripsLinkTarget {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

/** The type of map marker */
export enum TripsMarkerType {
  ACTIVITYEVENTMARKER = "ActivityEventMarker",
  ACTIVITYGUESTPICKUPMARKER = "ActivityGuestPickupMarker",
  ACTIVITYLOCATIONMARKER = "ActivityLocationMarker",
  ACTIVITYREDEMPTIONMARKER = "ActivityRedemptionMarker",
  AIRPORTMARKER = "AirportMarker",
  CARMARKER = "CarMarker",
  CRUISEMARKER = "CruiseMarker",
  HOTELMARKER = "HotelMarker",
  PLACEMARKER = "PlaceMarker",
}

/**
 * The `TripsPlanInput` contains an itemId and source. The `itemId` represents the identifier of the item being saved, e.g hotel id.
 * The `source` is the page or view from which the save is being requested.
 */
export interface TripsPlanInput {
  itemId: Scalars["String"];
  source: TripsPlanSourceType;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  HOTEL_SEARCH = "HOTEL_SEARCH",
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: Maybe<DateTimeInput>;
  checkoutDate?: Maybe<DateTimeInput>;
  propertyId: Scalars["String"];
  roomConfiguration?: Maybe<Array<TripsStayRoomTravelerInfoInput>>;
}

/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UiLinkTarget {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export interface UriContextAttributesInput {
  gaiaType?: Maybe<Scalars["String"]>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars["String"];
}

export interface UserLocationInput {
  userCountryCode?: Maybe<Scalars["String"]>;
  userLatitude?: Maybe<Scalars["BigDecimal"]>;
  userLongitude?: Maybe<Scalars["BigDecimal"]>;
  userSelectedOrigin?: Maybe<Scalars["String"]>;
}

export type BlossomCustomerNotificationQueryVariables = Exact<{
  context: ContextInput;
  notificationLocation: NotificationLocation;
  lineOfBusiness: ExpLineOfBusiness;
  funnelLocation: FunnelLocation;
}>;

export type BlossomCustomerNotificationQuery = {
  __typename: "Query";
  customer: {
    __typename: "Customer";
    notification: {
      __typename: "CustomerNotification";
      type: CustomerNotificationType;
      backgroundId?: Maybe<string>;
      title?: Maybe<{
        __typename: "CustomerNotificationPhrase";
        items: Array<
          | {
              __typename: "CustomerNotificationPhraseLinkNode";
              url?: Maybe<any>;
              target?: Maybe<CustomerNotificationLinkTarget>;
              text: string;
              styles: Array<CustomerNotificationPhrasePartStyle>;
              actions?: Maybe<
                Array<
                  | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
                  | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
                  | { __typename: "CustomerNotificationMarketing" }
                  | { __typename: "CustomerNotificationModifiableAttributes" }
                  | { __typename: "CustomerNotificationSpecifications" }
                >
              >;
            }
          | {
              __typename: "CustomerNotificationPhraseTextNode";
              text: string;
              styles: Array<CustomerNotificationPhrasePartStyle>;
            }
        >;
      }>;
      body?: Maybe<
        Array<{
          __typename: "CustomerNotificationPhrase";
          items: Array<
            | {
                __typename: "CustomerNotificationPhraseLinkNode";
                url?: Maybe<any>;
                target?: Maybe<CustomerNotificationLinkTarget>;
                id?: Maybe<string>;
                text: string;
                styles: Array<CustomerNotificationPhrasePartStyle>;
                actions?: Maybe<
                  Array<
                    | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
                    | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
                    | { __typename: "CustomerNotificationMarketing" }
                    | { __typename: "CustomerNotificationModifiableAttributes" }
                    | { __typename: "CustomerNotificationSpecifications" }
                  >
                >;
                icon?: Maybe<{ __typename: "Icon"; id: string; description: string }>;
              }
            | {
                __typename: "CustomerNotificationPhraseTextNode";
                text: string;
                styles: Array<CustomerNotificationPhrasePartStyle>;
              }
          >;
        }>
      >;
      containerLink?: Maybe<{
        __typename: "CustomerNotificationContainerLink";
        url?: Maybe<any>;
        target?: Maybe<CustomerNotificationLinkTarget>;
        actions?: Maybe<
          Array<
            | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
            | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
            | { __typename: "CustomerNotificationMarketing" }
            | { __typename: "CustomerNotificationModifiableAttributes" }
            | { __typename: "CustomerNotificationSpecifications" }
          >
        >;
      }>;
      logo?: Maybe<{ __typename: "Image"; description: string; url: any }>;
      links?: Maybe<
        Array<{
          __typename: "CustomerNotificationPhraseLinkNode";
          id?: Maybe<string>;
          text: string;
          url?: Maybe<any>;
          icon?: Maybe<{ __typename: "Icon"; id: string; description: string }>;
          actions?: Maybe<
            Array<
              | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
              | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
              | { __typename: "CustomerNotificationMarketing" }
              | { __typename: "CustomerNotificationModifiableAttributes" }
              | { __typename: "CustomerNotificationSpecifications" }
            >
          >;
        }>
      >;
      dismiss?: Maybe<{
        __typename: "CustomerNotificationDismiss";
        icon: { __typename: "Icon"; id: string; description: string };
        actions?: Maybe<
          Array<
            | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
            | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
            | { __typename: "CustomerNotificationMarketing" }
            | { __typename: "CustomerNotificationModifiableAttributes" }
            | { __typename: "CustomerNotificationSpecifications" }
          >
        >;
      }>;
      revealActions?: Maybe<
        Array<
          | { __typename: "CustomerNotificationAnalytics"; description?: Maybe<string>; referrerId: string }
          | { __typename: "CustomerNotificationCookie"; name: string; value: string; expires: string }
          | { __typename: "CustomerNotificationMarketing" }
          | { __typename: "CustomerNotificationModifiableAttributes" }
          | { __typename: "CustomerNotificationSpecifications" }
        >
      >;
      backgroundImage?: Maybe<{ __typename: "Image"; url: any }>;
    };
  };
};

export type CampaignByIdQueryQueryVariables = Exact<{
  productType?: Maybe<Array<CampaignProductType> | CampaignProductType>;
  context: ContextInput;
  userLocation?: Maybe<UserLocationInput>;
  referrer?: Maybe<Scalars["String"]>;
  enableTripAttach?: Maybe<Scalars["Boolean"]>;
  displayPropertyCount?: Maybe<Scalars["Boolean"]>;
  campaignId: Scalars["String"];
  pageSize?: Maybe<Scalars["Int"]>;
  pageNumber: Scalars["Int"];
  enableLivePricing?: Maybe<Scalars["Boolean"]>;
  returnPath?: Maybe<Scalars["String"]>;
}>;

export type CampaignByIdQueryQuery = {
  __typename: "Query";
  campaignRecommendations?: Maybe<{
    __typename: "RecommendedCampaigns";
    responseId: any;
    campaigns: Array<{
      __typename: "CampaignDetail";
      id: string;
      headline: string;
      fromOriginHeaderText?: Maybe<string>;
      termsAndConditions: string;
      productTypes: Array<string>;
      recommendedType: RecommendedType;
      campaignContentPaginationInfo?: Maybe<{
        __typename: "CampaignContentPaginationInfo";
        hasMoreContentPages: boolean;
      }>;
      description: { __typename: "CampaignDescriptions"; short?: Maybe<string>; long?: Maybe<string> };
      offers?: Maybe<
        Array<
          | {
              __typename: "ActivityOfferItem";
              title?: Maybe<string>;
              description?: Maybe<string>;
              duration?: Maybe<string>;
              durationLabel?: Maybe<string>;
              city: string;
              province?: Maybe<string>;
              dates?: Maybe<string>;
              freeCancellationMessage?: Maybe<string>;
              name: string;
              secondaryContent?: Maybe<string>;
              badge?: Maybe<{ __typename: "CampaignOfferBadge"; text?: Maybe<string>; type: CampaignOfferBadgeType }>;
              image: { __typename: "Image"; description: string; url: any };
              activityOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  allyText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string; qualifierText: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
            }
          | {
              __typename: "DestinationOfferItem";
              affinities?: Maybe<Array<string>>;
              propertyCount?: Maybe<string>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              lodgingOffer?: Maybe<{
                __typename: "OfferData";
                price: { __typename: "OfferPrice"; value: string; qualifierText: string; disclaimerText: string };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              flightOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  prefixText?: Maybe<string>;
                };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              packageOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "FlightOfferItem";
              airlineName?: Maybe<string>;
              originCity?: Maybe<string>;
              originAirportCode?: Maybe<string>;
              destinationCity?: Maybe<string>;
              destinationAirportCode?: Maybe<string>;
              tripType?: Maybe<string>;
              flightClass?: Maybe<string>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              airlineImage?: Maybe<{ __typename: "Image"; description: string; url: any }>;
              flightOffer?: Maybe<{
                __typename: "OfferData";
                price: { __typename: "OfferPrice"; value: string; qualifierText: string; prefixText?: Maybe<string> };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "HotelOfferItem";
              location?: Maybe<string>;
              starRating?: Maybe<number>;
              guestReviewRating?: Maybe<string>;
              guestReviewRatingQualifierText?: Maybe<string>;
              guestReviewCount?: Maybe<string>;
              vipMessage?: Maybe<string>;
              freeCancellationMessage?: Maybe<string>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              badge?: Maybe<{ __typename: "CampaignOfferBadge"; text?: Maybe<string>; type: CampaignOfferBadgeType }>;
              discountBadge?: Maybe<{
                __typename: "CampaignOfferBadge";
                text?: Maybe<string>;
                type: CampaignOfferBadgeType;
              }>;
              mod?: Maybe<{
                __typename: "MODItem";
                modTagText?: Maybe<string>;
                modAvailabilityText?: Maybe<string>;
                modSignInText?: Maybe<string>;
                signInUrl?: Maybe<{ __typename: "HttpURI"; value: string; relativePath: string }>;
              }>;
              lodgingOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  allyText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "PackageOfferItem";
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              flightOfferItem?: Maybe<{
                __typename: "FlightOfferItem";
                airlineName?: Maybe<string>;
                originCity?: Maybe<string>;
                originAirportCode?: Maybe<string>;
                destinationCity?: Maybe<string>;
                destinationAirportCode?: Maybe<string>;
                airlineImage?: Maybe<{ __typename: "Image"; description: string; url: any }>;
              }>;
              hotelOfferItem?: Maybe<{
                __typename: "HotelOfferItem";
                name: string;
                location?: Maybe<string>;
                vipMessage?: Maybe<string>;
              }>;
              packageOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "PropertyOfferItem";
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              image: { __typename: "Image"; description: string; url: any };
            }
        >
      >;
    }>;
    paginationInfo: { __typename: "CampaignPagination"; referrer: string };
  }>;
};

export type CampaignRecommendationsWithOffersQueryQueryVariables = Exact<{
  numCampaigns: Scalars["Int"];
  pageNumberOfCampaigns: Scalars["Int"];
  maxNumberOfCampaigns?: Maybe<Scalars["Int"]>;
  productType?: Maybe<Array<CampaignProductType> | CampaignProductType>;
  recommendationType?: Maybe<Array<Maybe<RecommendedType>> | Maybe<RecommendedType>>;
  context: ContextInput;
  userLocation?: Maybe<UserLocationInput>;
  referrer?: Maybe<Scalars["String"]>;
  userTripState?: Maybe<Scalars["String"]>;
  enableLivePricing?: Maybe<Scalars["Boolean"]>;
  returnPath?: Maybe<Scalars["String"]>;
}>;

export type CampaignRecommendationsWithOffersQueryQuery = {
  __typename: "Query";
  campaignRecommendations?: Maybe<{
    __typename: "RecommendedCampaigns";
    responseId: any;
    campaigns: Array<{
      __typename: "CampaignDetail";
      id: string;
      headline: string;
      fromOriginHeaderText?: Maybe<string>;
      termsAndConditions: string;
      productTypes: Array<string>;
      recommendedType: RecommendedType;
      description: { __typename: "CampaignDescriptions"; short?: Maybe<string>; long?: Maybe<string> };
      offers?: Maybe<
        Array<
          | {
              __typename: "ActivityOfferItem";
              title?: Maybe<string>;
              description?: Maybe<string>;
              duration?: Maybe<string>;
              durationLabel?: Maybe<string>;
              city: string;
              province?: Maybe<string>;
              dates?: Maybe<string>;
              freeCancellationMessage?: Maybe<string>;
              name: string;
              secondaryContent?: Maybe<string>;
              badge?: Maybe<{ __typename: "CampaignOfferBadge"; text?: Maybe<string>; type: CampaignOfferBadgeType }>;
              image: { __typename: "Image"; description: string; url: any };
              activityOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  allyText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string; qualifierText: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
            }
          | {
              __typename: "DestinationOfferItem";
              affinities?: Maybe<Array<string>>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              lodgingOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              flightOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              packageOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "FlightOfferItem";
              airlineName?: Maybe<string>;
              originCity?: Maybe<string>;
              originAirportCode?: Maybe<string>;
              destinationCity?: Maybe<string>;
              destinationAirportCode?: Maybe<string>;
              tripType?: Maybe<string>;
              flightClass?: Maybe<string>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              airlineImage?: Maybe<{ __typename: "Image"; description: string; url: any }>;
              flightOffer?: Maybe<{
                __typename: "OfferData";
                price: { __typename: "OfferPrice"; value: string; qualifierText: string; prefixText?: Maybe<string> };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "HotelOfferItem";
              location?: Maybe<string>;
              starRating?: Maybe<number>;
              guestReviewRating?: Maybe<string>;
              guestReviewRatingQualifierText?: Maybe<string>;
              guestReviewCount?: Maybe<string>;
              vipMessage?: Maybe<string>;
              freeCancellationMessage?: Maybe<string>;
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              badge?: Maybe<{ __typename: "CampaignOfferBadge"; text?: Maybe<string>; type: CampaignOfferBadgeType }>;
              discountBadge?: Maybe<{
                __typename: "CampaignOfferBadge";
                text?: Maybe<string>;
                type: CampaignOfferBadgeType;
              }>;
              mod?: Maybe<{
                __typename: "MODItem";
                modTagText?: Maybe<string>;
                modAvailabilityText?: Maybe<string>;
                modSignInText?: Maybe<string>;
                signInUrl?: Maybe<{ __typename: "HttpURI"; value: string; relativePath: string }>;
              }>;
              lodgingOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  disclaimerText: string;
                  allyText?: Maybe<string>;
                };
                strikeThroughPrice?: Maybe<{ __typename: "OfferPrice"; value: string }>;
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "PackageOfferItem";
              dates?: Maybe<string>;
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              flightOfferItem?: Maybe<{
                __typename: "FlightOfferItem";
                airlineName?: Maybe<string>;
                originCity?: Maybe<string>;
                originAirportCode?: Maybe<string>;
                destinationCity?: Maybe<string>;
                destinationAirportCode?: Maybe<string>;
                airlineImage?: Maybe<{ __typename: "Image"; description: string; url: any }>;
              }>;
              hotelOfferItem?: Maybe<{
                __typename: "HotelOfferItem";
                name: string;
                location?: Maybe<string>;
                vipMessage?: Maybe<string>;
              }>;
              packageOffer?: Maybe<{
                __typename: "OfferData";
                price: {
                  __typename: "OfferPrice";
                  value: string;
                  qualifierText: string;
                  prefixText?: Maybe<string>;
                  checkPriceText?: Maybe<string>;
                };
                actionLink: { __typename: "OfferActionLink"; href: string; text: string };
              }>;
              image: { __typename: "Image"; description: string; url: any };
            }
          | {
              __typename: "PropertyOfferItem";
              name: string;
              description?: Maybe<string>;
              secondaryContent?: Maybe<string>;
              image: { __typename: "Image"; description: string; url: any };
            }
        >
      >;
    }>;
    paginationInfo: { __typename: "CampaignPagination"; referrer: string; hasNextPage: boolean };
  }>;
};

export type CustomerPropertySearchByIdQueryQueryVariables = Exact<{
  context: ContextInput;
  dateRange?: Maybe<PropertyDateRangeInput>;
  hotelIds?: Maybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type CustomerPropertySearchByIdQueryQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    properties: Array<{
      __typename: "Property";
      name: string;
      id: string;
      infositeURL: string;
      price?: Maybe<{
        __typename: "PropertyPrice";
        options?: Maybe<
          Array<{
            __typename: "PropertyPriceOption";
            displayPrice?: Maybe<{
              __typename: "Money";
              formatted: string;
              amount: number;
              currencyInfo?: Maybe<{ __typename: "Currency"; symbol: string; code: string; name: string }>;
            }>;
          }>
        >;
      }>;
      image?: Maybe<{ __typename: "Image"; url: any }>;
    }>;
    searchCriteria: {
      __typename: "SearchCriteria";
      dateRange: {
        __typename: "PropertyDateRange";
        checkInDate: { __typename: "Date"; isoFormat: string; day: number; month: number; year: number };
        checkOutDate: { __typename: "Date"; isoFormat: string; day: number; month: number; year: number };
      };
    };
  };
};

export type CustomerSearchHistoryAllQueryQueryVariables = Exact<{
  context: ContextInput;
  lobs?: Maybe<Array<HistoryType> | HistoryType>;
  numberOfResults?: Maybe<Scalars["Int"]>;
}>;

export type CustomerSearchHistoryAllQueryQuery = {
  __typename: "Query";
  customer: {
    __typename: "Customer";
    searchHistory?: Maybe<
      Array<{
        __typename: "History";
        type?: Maybe<HistoryType>;
        items?: Maybe<
          Array<
            Maybe<{
              __typename: "HistoryItem";
              id?: Maybe<string>;
              localizedDateRange?: Maybe<string>;
              localizedAsOfDateTime?: Maybe<string>;
              lastViewedDate: {
                __typename: "ZonedDateTime";
                day: number;
                hour: number;
                minute: number;
                second: number;
                month: number;
                year: number;
              };
              startDate: { __typename: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
              endDate: { __typename: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
              originalSearchPrice?: Maybe<{
                __typename: "Money";
                amount: number;
                formatted: string;
                currencyInfo?: Maybe<{ __typename: "Currency"; code: string; name: string; symbol: string }>;
              }>;
              productInfo?: Maybe<
                | {
                    __typename: "HistoryActivityDetail";
                    name?: Maybe<string>;
                    duration?: Maybe<string>;
                    leadTicketType?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                    imageUrl?: Maybe<{ __typename: "Image"; description: string; url: any }>;
                  }
                | {
                    __typename: "HistoryActivitySearch";
                    searchUrl?: Maybe<string>;
                    regionDetail?: Maybe<{ __typename: "GeographicFeature"; name: string }>;
                  }
                | { __typename: "HistoryCarDetail" }
                | { __typename: "HistoryCarSearch" }
                | { __typename: "HistoryCruiseSearch" }
                | {
                    __typename: "HistoryFlightDetail";
                    localizedFlightName?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                    routeType?: Maybe<string>;
                    flightPassengers?: Maybe<{
                      __typename: "FlightPassengers";
                      adults?: Maybe<number>;
                      agesOfChildren?: Maybe<Array<number>>;
                    }>;
                  }
                | {
                    __typename: "HistoryFlightSearch";
                    localizedFlightName?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                    routeType?: Maybe<string>;
                    flightPassengers?: Maybe<{
                      __typename: "FlightPassengers";
                      adults?: Maybe<number>;
                      agesOfChildren?: Maybe<Array<number>>;
                    }>;
                  }
                | {
                    __typename: "HistoryPackageSearch";
                    localizedPackageName?: Maybe<string>;
                    localizedRegionName?: Maybe<string>;
                    localizedPackagesTemplate?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                  }
                | {
                    __typename: "HistoryPropertyDetail";
                    regionId?: Maybe<string>;
                    formattedRating: string;
                    formattedReviewCount: string;
                    propertyId?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                    summary?: Maybe<{ __typename: "PropertySummary"; id: string; name: string }>;
                    regionDetail?: Maybe<{ __typename: "GeographicFeature"; name: string }>;
                    reviewInfo?: Maybe<{
                      __typename: "PropertyReviews";
                      summary: {
                        __typename: "PropertyReviewSummary";
                        averageOverallRating: { __typename: "FormattedNumber"; formatted: string };
                        totalCount: { __typename: "FormattedNumber"; formatted: string };
                      };
                    }>;
                    gallery?: Maybe<{
                      __typename: "PropertyGallery";
                      featured?: Maybe<{ __typename: "Image"; description: string; url: any }>;
                    }>;
                  }
                | {
                    __typename: "HistoryPropertySearch";
                    localizedRoomsTemplate?: Maybe<string>;
                    searchUrl?: Maybe<string>;
                    regionDetail?: Maybe<{ __typename: "GeographicFeature"; name: string }>;
                  }
              >;
            }>
          >
        >;
      }>
    >;
  };
};

export type CustomerSearchHistoryQueryQueryVariables = Exact<{
  context: ContextInput;
  lobs?: Maybe<Array<HistoryType> | HistoryType>;
  numberOfResults?: Maybe<Scalars["Int"]>;
}>;

export type CustomerSearchHistoryQueryQuery = {
  __typename: "Query";
  customer: {
    __typename: "Customer";
    searchHistory?: Maybe<
      Array<{
        __typename: "History";
        type?: Maybe<HistoryType>;
        items?: Maybe<
          Array<
            Maybe<{
              __typename: "HistoryItem";
              startDate: { __typename: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
              endDate: { __typename: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
              originalSearchPrice?: Maybe<{
                __typename: "Money";
                amount: number;
                formatted: string;
                currencyInfo?: Maybe<{ __typename: "Currency"; code: string; name: string; symbol: string }>;
              }>;
              productInfo?: Maybe<
                | { __typename: "HistoryActivityDetail" }
                | { __typename: "HistoryActivitySearch" }
                | { __typename: "HistoryCarDetail" }
                | { __typename: "HistoryCarSearch" }
                | { __typename: "HistoryCruiseSearch" }
                | { __typename: "HistoryFlightDetail" }
                | { __typename: "HistoryFlightSearch" }
                | { __typename: "HistoryPackageSearch" }
                | {
                    __typename: "HistoryPropertyDetail";
                    regionId?: Maybe<string>;
                    propertyId?: Maybe<string>;
                    summary?: Maybe<{ __typename: "PropertySummary"; id: string; name: string }>;
                    gallery?: Maybe<{
                      __typename: "PropertyGallery";
                      featured?: Maybe<{ __typename: "Image"; url: any }>;
                    }>;
                  }
                | { __typename: "HistoryPropertySearch" }
              >;
            }>
          >
        >;
      }>
    >;
  };
};

export type DxPropertySearchQueryQueryVariables = Exact<{
  context: ContextInput;
  hotelIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type DxPropertySearchQueryQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    properties: Array<{
      __typename: "Property";
      id: string;
      name: string;
      infositeURL: string;
      price?: Maybe<{
        __typename: "PropertyPrice";
        lead?: Maybe<{ __typename: "Money"; formatted: string; amount: number }>;
      }>;
      reviews: { __typename: "PropertyReviewsSummary"; score?: Maybe<number>; total?: Maybe<number> };
      gallery?: Maybe<Array<{ __typename: "Image"; url: any; description: string }>>;
    }>;
  };
};

export type MapPropertySearchByIdQueryVariables = Exact<{
  context: ContextInput;
  rooms?: Maybe<Array<RoomInput> | RoomInput>;
  dateRange?: Maybe<PropertyDateRangeInput>;
  propertyIds?: Maybe<Array<Scalars["String"]> | Scalars["String"]>;
  filters?: Maybe<PropertySearchFiltersInput>;
}>;

export type MapPropertySearchByIdQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    sortAndFilter: {
      __typename: "SortAndFilter";
      options?: Maybe<{
        __typename: "SortAndFilterViewModel";
        sortAndFilter: Array<{
          __typename: "FilterViewModel";
          name: string;
          options: Array<{
            __typename: "OptionViewModel";
            label?: Maybe<string>;
            value?: Maybe<string>;
            enumValue?: Maybe<string>;
            range?: Maybe<{ __typename: "FilterOptionRange"; min?: Maybe<number>; max?: Maybe<number> }>;
          }>;
        }>;
      }>;
    };
    properties: Array<{
      __typename: "Property";
      name: string;
      id: string;
      infositeURL: string;
      star?: Maybe<number>;
      price?: Maybe<{
        __typename: "PropertyPrice";
        lead?: Maybe<{
          __typename: "Money";
          formatted: string;
          amount: number;
          currencyInfo?: Maybe<{ __typename: "Currency"; symbol: string; code: string; name: string }>;
        }>;
      }>;
      reviews: {
        __typename: "PropertyReviewsSummary";
        score?: Maybe<number>;
        total?: Maybe<number>;
        localizedSubtitle?: Maybe<string>;
      };
      image?: Maybe<{ __typename: "Image"; url: any }>;
      mapMarker?: Maybe<{
        __typename: "MapMarker";
        latLong: { __typename: "Coordinates"; latitude: number; longitude: number };
      }>;
    }>;
  };
};

export type MapPropertySearchByLatLongQueryVariables = Exact<{
  context: ContextInput;
  rooms?: Maybe<Array<RoomInput> | RoomInput>;
  dateRange?: Maybe<PropertyDateRangeInput>;
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
  filters?: Maybe<PropertySearchFiltersInput>;
  size?: Maybe<Scalars["Int"]>;
}>;

export type MapPropertySearchByLatLongQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    properties: Array<{
      __typename: "Property";
      name: string;
      id: string;
      infositeURL: string;
      star?: Maybe<number>;
      price?: Maybe<{
        __typename: "PropertyPrice";
        lead?: Maybe<{ __typename: "Money"; formatted: string; amount: number }>;
      }>;
      reviews: {
        __typename: "PropertyReviewsSummary";
        score?: Maybe<number>;
        total?: Maybe<number>;
        localizedSubtitle?: Maybe<string>;
      };
      image?: Maybe<{ __typename: "Image"; url: any }>;
      mapMarker?: Maybe<{
        __typename: "MapMarker";
        latLong: { __typename: "Coordinates"; latitude: number; longitude: number };
      }>;
    }>;
    summary: {
      __typename: "PropertyResultsSummary";
      messages?: Maybe<
        Array<{
          __typename: "MessageResult";
          type?: Maybe<MessageType>;
          title?: Maybe<{ __typename: "MessagingResultTitle"; text?: Maybe<string> }>;
          subtitle?: Maybe<{ __typename: "MessagingResultTitle"; text?: Maybe<string> }>;
        }>
      >;
    };
  };
};

export type MerchCouponsQueryQueryVariables = Exact<{
  context: ContextInput;
  couponIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type MerchCouponsQueryQuery = {
  __typename: "Query";
  merchCoupons?: Maybe<{
    __typename: "MerchCoupons";
    coupons: Array<{
      __typename: "CouponDetail";
      id: string;
      name: string;
      statusMessage: string;
      termsAndConditions: {
        __typename: "CouponTermsAndConditions";
        text: string;
        informationUrl: { __typename: "HttpURI"; value: string };
      };
    }>;
  }>;
};

export type PropertyFilterSearchQueryQueryVariables = Exact<{
  context: ContextInput;
  regionId: Scalars["String"];
  filters?: Maybe<PropertySearchFiltersInput>;
  sort?: Maybe<PropertySort>;
  searchPagination?: Maybe<PaginationInput>;
}>;

export type PropertyFilterSearchQueryQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    sortAndFilter: {
      __typename: "SortAndFilter";
      selected?: Maybe<{
        __typename: "SortAndFilterSelected";
        priceFilterPills?: Maybe<{
          __typename: "PriceFilterPills";
          aggregate?: Maybe<{ __typename: "PriceFilterPillsAggregate"; label?: Maybe<string> }>;
        }>;
      }>;
    };
    propertySearchListings: Array<
      | { __typename: "LodgingHeading" }
      | {
          __typename: "MessageResult";
          index?: Maybe<number>;
          type?: Maybe<MessageType>;
          title?: Maybe<{
            __typename: "MessagingResultTitle";
            text?: Maybe<string>;
            icon?: Maybe<{ __typename: "Icon"; description: string; id: string }>;
          }>;
          subtitle?: Maybe<{ __typename: "MessagingResultTitle"; text?: Maybe<string> }>;
        }
      | {
          __typename: "Property";
          id: string;
          name: string;
          addressMessaging?: Maybe<string>;
          star?: Maybe<number>;
          structureType: StructureType;
          offerSummary: {
            __typename: "OfferSummary";
            messages?: Maybe<Array<{ __typename: "OfferSummaryMessage"; type?: Maybe<string> }>>;
          };
          propertyImage?: Maybe<{ __typename: "PropertyImage"; image: { __typename: "Image"; url: any } }>;
          destinationInfo: {
            __typename: "PropertyDestinationInfo";
            distanceFromMessaging?: Maybe<string>;
            distanceFromDestination?: Maybe<{ __typename: "Distance"; unit: DistanceUnit; value: number }>;
          };
          mapMarker?: Maybe<{
            __typename: "MapMarker";
            latLong: { __typename: "Coordinates"; latitude: number; longitude: number };
          }>;
          reviews: { __typename: "PropertyReviewsSummary"; score?: Maybe<number>; total?: Maybe<number> };
          price?: Maybe<{
            __typename: "PropertyPrice";
            priceMessages?: Maybe<Array<{ __typename: "LodgingPlainMessage"; value: string }>>;
            options?: Maybe<
              Array<{
                __typename: "PropertyPriceOption";
                displayPrice?: Maybe<{
                  __typename: "Money";
                  amount: number;
                  formatted: string;
                  currencyInfo?: Maybe<{ __typename: "Currency"; code: string }>;
                }>;
              }>
            >;
          }>;
          propertyDetailsLink?: Maybe<{
            __typename: "LodgingLink";
            uri: { __typename: "HttpURI"; relativePath: string; value: string };
          }>;
        }
      | { __typename: "StaticLodgingMultiItemCrossSell" }
    >;
  };
};

export type PropertyFiltersQueryQueryVariables = Exact<{
  context: ContextInput;
  regionId: Scalars["String"];
  filters?: Maybe<PropertySearchFiltersInput>;
  sort?: Maybe<PropertySort>;
}>;

export type PropertyFiltersQueryQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    sortAndFilter: {
      __typename: "SortAndFilter";
      options?: Maybe<{
        __typename: "SortAndFilterViewModel";
        sortAndFilter: Array<{
          __typename: "FilterViewModel";
          label?: Maybe<string>;
          name: string;
          options: Array<{
            __typename: "OptionViewModel";
            label?: Maybe<string>;
            optionValue?: Maybe<string>;
            filterCategory?: Maybe<string>;
            description?: Maybe<string>;
            selectedLabel?: Maybe<string>;
            isSelected: boolean;
            range?: Maybe<{ __typename: "FilterOptionRange"; max?: Maybe<number>; min?: Maybe<number> }>;
          }>;
        }>;
      }>;
    };
  };
};

export type QueryPropertyHeroImageQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars["String"];
}>;

export type QueryPropertyHeroImageQuery = {
  __typename: "Query";
  propertyInfo: {
    __typename: "PropertyInfo";
    gallery?: Maybe<{
      __typename: "PropertyGallery";
      featured?: Maybe<{ __typename: "Image"; description: string; url: any }>;
    }>;
  };
};

export type QueryPropertyReviewsHeadlineQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars["String"];
}>;

export type QueryPropertyReviewsHeadlineQuery = {
  __typename: "Query";
  propertyInfo: {
    __typename: "PropertyInfo";
    infositeUrl?: Maybe<any>;
    summary?: Maybe<{
      __typename: "PropertySummary";
      id: string;
      name: string;
      overview?: Maybe<{ __typename: "PropertyOverview"; starRating?: Maybe<number> }>;
      location?: Maybe<{
        __typename: "PropertyLocation";
        address?: Maybe<{
          __typename: "PropertyAddress";
          city?: Maybe<string>;
          countryCode?: Maybe<string>;
          firstAddressLine?: Maybe<string>;
          secondAddressLine?: Maybe<string>;
          postalCode?: Maybe<string>;
          province?: Maybe<string>;
        }>;
      }>;
    }>;
  };
};

export type PropertySearchQueryQueryVariables = Exact<{
  context: ContextInput;
  hotelIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type PropertySearchQueryQuery = {
  __typename: "Query";
  propertySearch: {
    __typename: "PropertySearchResults";
    properties: Array<{
      __typename: "Property";
      id: string;
      name: string;
      gallery?: Maybe<Array<{ __typename: "Image"; url: any; description: string }>>;
    }>;
  };
};

export type SingleAdRequestOperationQueryVariables = Exact<{
  context: ContextInput;
  sponsoredContentTarget: SponsoredContentTargetInput;
}>;

export type SingleAdRequestOperationQuery = {
  __typename: "Query";
  singleAdRequest: {
    __typename: "SponsoredContentSingleAdRequestResponse";
    marquees?: Maybe<
      Array<{
        __typename: "SponsoredContentMarquee";
        sponsoredContentId: string;
        heading: string;
        paragraph: string;
        badgeLabel: string;
        renderBeacon: any;
        clickBeacon: any;
        viewabilityBeacon: any;
        callToAction?: Maybe<{
          __typename: "SponsoredContentMarqueeCallToAction";
          text: string;
          type: SponsoredContentElementType;
        }>;
        logo?: Maybe<{ __typename: "SponsoredContentLogoImage"; altText: string; standardUrl: any }>;
        image: {
          __typename: "SponsoredContentFeatureImage";
          altText: string;
          standardUrl: any;
          portraitUrl?: Maybe<any>;
          widescreenUrl?: Maybe<any>;
        };
        link: { __typename: "SponsoredContentLink"; url: any; target?: Maybe<string> };
      }>
    >;
  };
};

export type TravelAgentSearchWizardConfigQueryQueryVariables = Exact<{
  context: ContextInput;
}>;

export type TravelAgentSearchWizardConfigQueryQuery = {
  __typename: "Query";
  travelAgentSearchWizardConfig?: Maybe<{
    __typename: "TravelAgentSearchWizardConfig";
    packageRatesEnabled: boolean;
    enabledLobs: Array<string>;
    packageRatesDetail?: Maybe<{
      __typename: "TravelAgentPackageRatesDetail";
      heading?: Maybe<string>;
      termsAndConditions: string;
    }>;
  }>;
};

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace BlossomCustomerNotification {
  export type Variables = BlossomCustomerNotificationQueryVariables;
  export type Query = BlossomCustomerNotificationQuery;
  export type Customer = NonNullable<BlossomCustomerNotificationQuery["customer"]>;
  export type Notification = NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>;
  export type Title = NonNullable<
    NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
  >;
  export type Items = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
      >["items"]
    >[number]
  >;
  export type CustomerNotificationPhraseLinkNodeInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
        >["items"]
      >[number]
    >,
    { __typename: "CustomerNotificationPhraseLinkNode" }
  >;
  export type Actions = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
            >["items"]
          >[number]
        >,
        { __typename: "CustomerNotificationPhraseLinkNode" }
      >["actions"]
    >[number]
  >;
  export type CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
              >["items"]
            >[number]
          >,
          { __typename: "CustomerNotificationPhraseLinkNode" }
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["title"]
              >["items"]
            >[number]
          >,
          { __typename: "CustomerNotificationPhraseLinkNode" }
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type Body = NonNullable<
    NonNullable<NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]>[number]
  >;
  export type _Items = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
        >[number]
      >["items"]
    >[number]
  >;
  export type _CustomerNotificationPhraseLinkNodeInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
          >[number]
        >["items"]
      >[number]
    >,
    { __typename: "CustomerNotificationPhraseLinkNode" }
  >;
  export type _Actions = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
              >[number]
            >["items"]
          >[number]
        >,
        { __typename: "CustomerNotificationPhraseLinkNode" }
      >["actions"]
    >[number]
  >;
  export type _CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
                >[number]
              >["items"]
            >[number]
          >,
          { __typename: "CustomerNotificationPhraseLinkNode" }
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type _CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
                >[number]
              >["items"]
            >[number]
          >,
          { __typename: "CustomerNotificationPhraseLinkNode" }
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type Icon = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["body"]
            >[number]
          >["items"]
        >[number]
      >,
      { __typename: "CustomerNotificationPhraseLinkNode" }
    >["icon"]
  >;
  export type ContainerLink = NonNullable<
    NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["containerLink"]
  >;
  export type __Actions = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["containerLink"]
      >["actions"]
    >[number]
  >;
  export type __CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["containerLink"]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type __CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["containerLink"]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type Logo = NonNullable<
    NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["logo"]
  >;
  export type Links = NonNullable<
    NonNullable<NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["links"]>[number]
  >;
  export type _Icon = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["links"]
      >[number]
    >["icon"]
  >;
  export type ___Actions = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["links"]
        >[number]
      >["actions"]
    >[number]
  >;
  export type ___CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["links"]
          >[number]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type ___CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["links"]
          >[number]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type Dismiss = NonNullable<
    NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["dismiss"]
  >;
  export type __Icon = NonNullable<
    NonNullable<
      NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["dismiss"]
    >["icon"]
  >;
  export type ____Actions = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["dismiss"]
      >["actions"]
    >[number]
  >;
  export type ____CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["dismiss"]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type ____CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["dismiss"]
        >["actions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type RevealActions = NonNullable<
    NonNullable<
      NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["revealActions"]
    >[number]
  >;
  export type _____CustomerNotificationAnalyticsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["revealActions"]
      >[number]
    >,
    { __typename: "CustomerNotificationAnalytics" }
  >;
  export type _____CustomerNotificationCookieInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["revealActions"]
      >[number]
    >,
    { __typename: "CustomerNotificationCookie" }
  >;
  export type BackgroundImage = NonNullable<
    NonNullable<NonNullable<BlossomCustomerNotificationQuery["customer"]>["notification"]>["backgroundImage"]
  >;
}

export namespace CampaignByIdQuery {
  export type Variables = CampaignByIdQueryQueryVariables;
  export type Query = CampaignByIdQueryQuery;
  export type CampaignRecommendations = NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>;
  export type Campaigns = NonNullable<
    NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
  >;
  export type CampaignContentPaginationInfo = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
    >["campaignContentPaginationInfo"]
  >;
  export type Description = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
    >["description"]
  >;
  export type Offers = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
      >["offers"]
    >[number]
  >;
  export type Image = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >["image"]
  >;
  export type DestinationOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >,
    { __typename: "DestinationOfferItem" }
  >;
  export type LodgingOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["lodgingOffer"]
  >;
  export type Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["lodgingOffer"]
    >["price"]
  >;
  export type ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["lodgingOffer"]
    >["actionLink"]
  >;
  export type FlightOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["flightOffer"]
  >;
  export type _Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["flightOffer"]
    >["price"]
  >;
  export type _ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["flightOffer"]
    >["actionLink"]
  >;
  export type PackageOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["packageOffer"]
  >;
  export type __Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["price"]
  >;
  export type StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["strikeThroughPrice"]
  >;
  export type __ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["actionLink"]
  >;
  export type HotelOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >,
    { __typename: "HotelOfferItem" }
  >;
  export type Badge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["badge"]
  >;
  export type DiscountBadge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["discountBadge"]
  >;
  export type Mod = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["mod"]
  >;
  export type SignInUrl = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["mod"]
    >["signInUrl"]
  >;
  export type _LodgingOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["lodgingOffer"]
  >;
  export type ___Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["price"]
  >;
  export type _StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["strikeThroughPrice"]
  >;
  export type ___ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["actionLink"]
  >;
  export type FlightOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >,
    { __typename: "FlightOfferItem" }
  >;
  export type AirlineImage = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "FlightOfferItem" }
    >["airlineImage"]
  >;
  export type _FlightOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "FlightOfferItem" }
    >["flightOffer"]
  >;
  export type ____Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "FlightOfferItem" }
      >["flightOffer"]
    >["price"]
  >;
  export type ____ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "FlightOfferItem" }
      >["flightOffer"]
    >["actionLink"]
  >;
  export type PackageOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >,
    { __typename: "PackageOfferItem" }
  >;
  export type FlightOfferItem = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["flightOfferItem"]
  >;
  export type _AirlineImage = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["flightOfferItem"]
    >["airlineImage"]
  >;
  export type HotelOfferItem = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["hotelOfferItem"]
  >;
  export type _PackageOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["packageOffer"]
  >;
  export type _____Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["packageOffer"]
    >["price"]
  >;
  export type _____ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["packageOffer"]
    >["actionLink"]
  >;
  export type ActivityOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
        >["offers"]
      >[number]
    >,
    { __typename: "ActivityOfferItem" }
  >;
  export type _Badge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["badge"]
  >;
  export type _Image = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["image"]
  >;
  export type ActivityOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["activityOffer"]
  >;
  export type ______Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["price"]
  >;
  export type __StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["strikeThroughPrice"]
  >;
  export type ______ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["campaigns"]>[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["actionLink"]
  >;
  export type PaginationInfo = NonNullable<
    NonNullable<CampaignByIdQueryQuery["campaignRecommendations"]>["paginationInfo"]
  >;
}

export namespace CampaignRecommendationsWithOffersQuery {
  export type Variables = CampaignRecommendationsWithOffersQueryQueryVariables;
  export type Query = CampaignRecommendationsWithOffersQueryQuery;
  export type CampaignRecommendations = NonNullable<
    CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]
  >;
  export type Campaigns = NonNullable<
    NonNullable<
      NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
    >[number]
  >;
  export type Description = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
      >[number]
    >["description"]
  >;
  export type Offers = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
        >[number]
      >["offers"]
    >[number]
  >;
  export type Image = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >["image"]
  >;
  export type DestinationOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >,
    { __typename: "DestinationOfferItem" }
  >;
  export type LodgingOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["lodgingOffer"]
  >;
  export type Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["lodgingOffer"]
    >["price"]
  >;
  export type ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["lodgingOffer"]
    >["actionLink"]
  >;
  export type FlightOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["flightOffer"]
  >;
  export type _Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["flightOffer"]
    >["price"]
  >;
  export type _ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["flightOffer"]
    >["actionLink"]
  >;
  export type PackageOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "DestinationOfferItem" }
    >["packageOffer"]
  >;
  export type __Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["price"]
  >;
  export type StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["strikeThroughPrice"]
  >;
  export type __ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "DestinationOfferItem" }
      >["packageOffer"]
    >["actionLink"]
  >;
  export type HotelOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >,
    { __typename: "HotelOfferItem" }
  >;
  export type Badge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["badge"]
  >;
  export type DiscountBadge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["discountBadge"]
  >;
  export type Mod = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["mod"]
  >;
  export type SignInUrl = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["mod"]
    >["signInUrl"]
  >;
  export type _LodgingOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "HotelOfferItem" }
    >["lodgingOffer"]
  >;
  export type ___Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["price"]
  >;
  export type _StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["strikeThroughPrice"]
  >;
  export type ___ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "HotelOfferItem" }
      >["lodgingOffer"]
    >["actionLink"]
  >;
  export type FlightOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >,
    { __typename: "FlightOfferItem" }
  >;
  export type AirlineImage = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "FlightOfferItem" }
    >["airlineImage"]
  >;
  export type _FlightOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "FlightOfferItem" }
    >["flightOffer"]
  >;
  export type ____Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "FlightOfferItem" }
      >["flightOffer"]
    >["price"]
  >;
  export type ____ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "FlightOfferItem" }
      >["flightOffer"]
    >["actionLink"]
  >;
  export type PackageOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >,
    { __typename: "PackageOfferItem" }
  >;
  export type FlightOfferItem = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["flightOfferItem"]
  >;
  export type _AirlineImage = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["flightOfferItem"]
    >["airlineImage"]
  >;
  export type HotelOfferItem = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["hotelOfferItem"]
  >;
  export type _PackageOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "PackageOfferItem" }
    >["packageOffer"]
  >;
  export type _____Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["packageOffer"]
    >["price"]
  >;
  export type _____ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "PackageOfferItem" }
      >["packageOffer"]
    >["actionLink"]
  >;
  export type ActivityOfferItemInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
          >[number]
        >["offers"]
      >[number]
    >,
    { __typename: "ActivityOfferItem" }
  >;
  export type _Badge = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["badge"]
  >;
  export type _Image = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["image"]
  >;
  export type ActivityOffer = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
            >[number]
          >["offers"]
        >[number]
      >,
      { __typename: "ActivityOfferItem" }
    >["activityOffer"]
  >;
  export type ______Price = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["price"]
  >;
  export type __StrikeThroughPrice = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["strikeThroughPrice"]
  >;
  export type ______ActionLink = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["campaigns"]
              >[number]
            >["offers"]
          >[number]
        >,
        { __typename: "ActivityOfferItem" }
      >["activityOffer"]
    >["actionLink"]
  >;
  export type PaginationInfo = NonNullable<
    NonNullable<CampaignRecommendationsWithOffersQueryQuery["campaignRecommendations"]>["paginationInfo"]
  >;
}

export namespace CustomerPropertySearchByIdQuery {
  export type Variables = CustomerPropertySearchByIdQueryQueryVariables;
  export type Query = CustomerPropertySearchByIdQueryQuery;
  export type PropertySearch = NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>;
  export type Properties = NonNullable<
    NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
  >;
  export type Price = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
    >["price"]
  >;
  export type Options = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
        >["price"]
      >["options"]
    >[number]
  >;
  export type DisplayPrice = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
          >["price"]
        >["options"]
      >[number]
    >["displayPrice"]
  >;
  export type CurrencyInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
            >["price"]
          >["options"]
        >[number]
      >["displayPrice"]
    >["currencyInfo"]
  >;
  export type Image = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["properties"]>[number]
    >["image"]
  >;
  export type SearchCriteria = NonNullable<
    NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["searchCriteria"]
  >;
  export type DateRange = NonNullable<
    NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["searchCriteria"]>["dateRange"]
  >;
  export type CheckInDate = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["searchCriteria"]>["dateRange"]
    >["checkInDate"]
  >;
  export type CheckOutDate = NonNullable<
    NonNullable<
      NonNullable<NonNullable<CustomerPropertySearchByIdQueryQuery["propertySearch"]>["searchCriteria"]>["dateRange"]
    >["checkOutDate"]
  >;
}

export namespace CustomerSearchHistoryAllQuery {
  export type Variables = CustomerSearchHistoryAllQueryQueryVariables;
  export type Query = CustomerSearchHistoryAllQueryQuery;
  export type Customer = NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>;
  export type SearchHistory = NonNullable<
    NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
  >;
  export type Items = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
      >["items"]
    >[number]
  >;
  export type LastViewedDate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["lastViewedDate"]
  >;
  export type StartDate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["startDate"]
  >;
  export type EndDate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["endDate"]
  >;
  export type OriginalSearchPrice = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["originalSearchPrice"]
  >;
  export type CurrencyInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["originalSearchPrice"]
    >["currencyInfo"]
  >;
  export type ProductInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["productInfo"]
  >;
  export type HistoryActivitySearchInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryActivitySearch" }
  >;
  export type RegionDetail = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryActivitySearch" }
    >["regionDetail"]
  >;
  export type HistoryActivityDetailInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryActivityDetail" }
  >;
  export type ImageUrl = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryActivityDetail" }
    >["imageUrl"]
  >;
  export type HistoryFlightSearchInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryFlightSearch" }
  >;
  export type FlightPassengers = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryFlightSearch" }
    >["flightPassengers"]
  >;
  export type HistoryFlightDetailInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryFlightDetail" }
  >;
  export type _FlightPassengers = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryFlightDetail" }
    >["flightPassengers"]
  >;
  export type HistoryPackageSearchInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryPackageSearch" }
  >;
  export type HistoryPropertySearchInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryPropertySearch" }
  >;
  export type _RegionDetail = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertySearch" }
    >["regionDetail"]
  >;
  export type HistoryPropertyDetailInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryPropertyDetail" }
  >;
  export type Summary = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["summary"]
  >;
  export type __RegionDetail = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["regionDetail"]
  >;
  export type ReviewInfo = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["reviewInfo"]
  >;
  export type _Summary = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
              >["items"]
            >[number]
          >["productInfo"]
        >,
        { __typename: "HistoryPropertyDetail" }
      >["reviewInfo"]
    >["summary"]
  >;
  export type AverageOverallRating = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
                >["items"]
              >[number]
            >["productInfo"]
          >,
          { __typename: "HistoryPropertyDetail" }
        >["reviewInfo"]
      >["summary"]
    >["averageOverallRating"]
  >;
  export type TotalCount = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
                >["items"]
              >[number]
            >["productInfo"]
          >,
          { __typename: "HistoryPropertyDetail" }
        >["reviewInfo"]
      >["summary"]
    >["totalCount"]
  >;
  export type Gallery = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["gallery"]
  >;
  export type Featured = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<CustomerSearchHistoryAllQueryQuery["customer"]>["searchHistory"]>[number]
              >["items"]
            >[number]
          >["productInfo"]
        >,
        { __typename: "HistoryPropertyDetail" }
      >["gallery"]
    >["featured"]
  >;
}

export namespace CustomerSearchHistoryQuery {
  export type Variables = CustomerSearchHistoryQueryQueryVariables;
  export type Query = CustomerSearchHistoryQueryQuery;
  export type Customer = NonNullable<CustomerSearchHistoryQueryQuery["customer"]>;
  export type SearchHistory = NonNullable<
    NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
  >;
  export type Items = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
      >["items"]
    >[number]
  >;
  export type StartDate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["startDate"]
  >;
  export type EndDate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["endDate"]
  >;
  export type OriginalSearchPrice = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["originalSearchPrice"]
  >;
  export type CurrencyInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["originalSearchPrice"]
    >["currencyInfo"]
  >;
  export type ProductInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
        >["items"]
      >[number]
    >["productInfo"]
  >;
  export type HistoryPropertyDetailInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
          >["items"]
        >[number]
      >["productInfo"]
    >,
    { __typename: "HistoryPropertyDetail" }
  >;
  export type Summary = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["summary"]
  >;
  export type Gallery = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
            >["items"]
          >[number]
        >["productInfo"]
      >,
      { __typename: "HistoryPropertyDetail" }
    >["gallery"]
  >;
  export type Featured = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<CustomerSearchHistoryQueryQuery["customer"]>["searchHistory"]>[number]
              >["items"]
            >[number]
          >["productInfo"]
        >,
        { __typename: "HistoryPropertyDetail" }
      >["gallery"]
    >["featured"]
  >;
}

export namespace DxPropertySearchQuery {
  export type Variables = DxPropertySearchQueryQueryVariables;
  export type Query = DxPropertySearchQueryQuery;
  export type PropertySearch = NonNullable<DxPropertySearchQueryQuery["propertySearch"]>;
  export type Properties = NonNullable<
    NonNullable<NonNullable<DxPropertySearchQueryQuery["propertySearch"]>["properties"]>[number]
  >;
  export type Price = NonNullable<
    NonNullable<NonNullable<NonNullable<DxPropertySearchQueryQuery["propertySearch"]>["properties"]>[number]>["price"]
  >;
  export type Lead = NonNullable<
    NonNullable<
      NonNullable<NonNullable<NonNullable<DxPropertySearchQueryQuery["propertySearch"]>["properties"]>[number]>["price"]
    >["lead"]
  >;
  export type Reviews = NonNullable<
    NonNullable<NonNullable<NonNullable<DxPropertySearchQueryQuery["propertySearch"]>["properties"]>[number]>["reviews"]
  >;
  export type Gallery = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<DxPropertySearchQueryQuery["propertySearch"]>["properties"]>[number]
      >["gallery"]
    >[number]
  >;
}

export namespace MapPropertySearchById {
  export type Variables = MapPropertySearchByIdQueryVariables;
  export type Query = MapPropertySearchByIdQuery;
  export type PropertySearch = NonNullable<MapPropertySearchByIdQuery["propertySearch"]>;
  export type SortAndFilter = NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["sortAndFilter"]>;
  export type Options = NonNullable<
    NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["sortAndFilter"]>["options"]
  >;
  export type _SortAndFilter = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["sortAndFilter"]>["options"]
      >["sortAndFilter"]
    >[number]
  >;
  export type _Options = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["sortAndFilter"]>["options"]
          >["sortAndFilter"]
        >[number]
      >["options"]
    >[number]
  >;
  export type Range = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["sortAndFilter"]>["options"]
            >["sortAndFilter"]
          >[number]
        >["options"]
      >[number]
    >["range"]
  >;
  export type Properties = NonNullable<
    NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]
  >;
  export type Price = NonNullable<
    NonNullable<NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]>["price"]
  >;
  export type Lead = NonNullable<
    NonNullable<
      NonNullable<NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]>["price"]
    >["lead"]
  >;
  export type CurrencyInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]
        >["price"]
      >["lead"]
    >["currencyInfo"]
  >;
  export type Reviews = NonNullable<
    NonNullable<NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]>["reviews"]
  >;
  export type Image = NonNullable<
    NonNullable<NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]>["image"]
  >;
  export type MapMarker = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]
    >["mapMarker"]
  >;
  export type LatLong = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByIdQuery["propertySearch"]>["properties"]>[number]
      >["mapMarker"]
    >["latLong"]
  >;
}

export namespace MapPropertySearchByLatLong {
  export type Variables = MapPropertySearchByLatLongQueryVariables;
  export type Query = MapPropertySearchByLatLongQuery;
  export type PropertySearch = NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>;
  export type Properties = NonNullable<
    NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
  >;
  export type Price = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
    >["price"]
  >;
  export type Lead = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
      >["price"]
    >["lead"]
  >;
  export type Reviews = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
    >["reviews"]
  >;
  export type Image = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
    >["image"]
  >;
  export type MapMarker = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
    >["mapMarker"]
  >;
  export type LatLong = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["properties"]>[number]
      >["mapMarker"]
    >["latLong"]
  >;
  export type Summary = NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["summary"]>;
  export type Messages = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["summary"]>["messages"]
    >[number]
  >;
  export type Title = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["summary"]>["messages"]
      >[number]
    >["title"]
  >;
  export type Subtitle = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MapPropertySearchByLatLongQuery["propertySearch"]>["summary"]>["messages"]
      >[number]
    >["subtitle"]
  >;
}

export namespace MerchCouponsQuery {
  export type Variables = MerchCouponsQueryQueryVariables;
  export type Query = MerchCouponsQueryQuery;
  export type MerchCoupons = NonNullable<MerchCouponsQueryQuery["merchCoupons"]>;
  export type Coupons = NonNullable<
    NonNullable<NonNullable<MerchCouponsQueryQuery["merchCoupons"]>["coupons"]>[number]
  >;
  export type TermsAndConditions = NonNullable<
    NonNullable<
      NonNullable<NonNullable<MerchCouponsQueryQuery["merchCoupons"]>["coupons"]>[number]
    >["termsAndConditions"]
  >;
  export type InformationUrl = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MerchCouponsQueryQuery["merchCoupons"]>["coupons"]>[number]
      >["termsAndConditions"]
    >["informationUrl"]
  >;
}

export namespace PropertyFilterSearchQuery {
  export type Variables = PropertyFilterSearchQueryQueryVariables;
  export type Query = PropertyFilterSearchQueryQuery;
  export type PropertySearch = NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>;
  export type SortAndFilter = NonNullable<
    NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["sortAndFilter"]
  >;
  export type Selected = NonNullable<
    NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["sortAndFilter"]>["selected"]
  >;
  export type PriceFilterPills = NonNullable<
    NonNullable<
      NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["sortAndFilter"]>["selected"]
    >["priceFilterPills"]
  >;
  export type Aggregate = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["sortAndFilter"]>["selected"]
      >["priceFilterPills"]
    >["aggregate"]
  >;
  export type PropertySearchListings = NonNullable<
    NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
  >;
  export type MessageResultInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
    >,
    { __typename: "MessageResult" }
  >;
  export type Title = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "MessageResult" }
    >["title"]
  >;
  export type Icon = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
        >,
        { __typename: "MessageResult" }
      >["title"]
    >["icon"]
  >;
  export type Subtitle = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "MessageResult" }
    >["subtitle"]
  >;
  export type PropertyInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
    >,
    { __typename: "Property" }
  >;
  export type OfferSummary = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["offerSummary"]
  >;
  export type Messages = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
          >,
          { __typename: "Property" }
        >["offerSummary"]
      >["messages"]
    >[number]
  >;
  export type PropertyImage = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["propertyImage"]
  >;
  export type Image = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
        >,
        { __typename: "Property" }
      >["propertyImage"]
    >["image"]
  >;
  export type DestinationInfo = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["destinationInfo"]
  >;
  export type DistanceFromDestination = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
        >,
        { __typename: "Property" }
      >["destinationInfo"]
    >["distanceFromDestination"]
  >;
  export type MapMarker = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["mapMarker"]
  >;
  export type LatLong = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
        >,
        { __typename: "Property" }
      >["mapMarker"]
    >["latLong"]
  >;
  export type Reviews = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["reviews"]
  >;
  export type Price = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["price"]
  >;
  export type PriceMessages = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
          >,
          { __typename: "Property" }
        >["price"]
      >["priceMessages"]
    >[number]
  >;
  export type Options = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
          >,
          { __typename: "Property" }
        >["price"]
      >["options"]
    >[number]
  >;
  export type DisplayPrice = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]
              >[number]
            >,
            { __typename: "Property" }
          >["price"]
        >["options"]
      >[number]
    >["displayPrice"]
  >;
  export type CurrencyInfo = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            DiscriminateUnion<
              NonNullable<
                NonNullable<
                  NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]
                >[number]
              >,
              { __typename: "Property" }
            >["price"]
          >["options"]
        >[number]
      >["displayPrice"]
    >["currencyInfo"]
  >;
  export type PropertyDetailsLink = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
      >,
      { __typename: "Property" }
    >["propertyDetailsLink"]
  >;
  export type Uri = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<NonNullable<PropertyFilterSearchQueryQuery["propertySearch"]>["propertySearchListings"]>[number]
        >,
        { __typename: "Property" }
      >["propertyDetailsLink"]
    >["uri"]
  >;
}

export namespace PropertyFiltersQuery {
  export type Variables = PropertyFiltersQueryQueryVariables;
  export type Query = PropertyFiltersQueryQuery;
  export type PropertySearch = NonNullable<PropertyFiltersQueryQuery["propertySearch"]>;
  export type SortAndFilter = NonNullable<NonNullable<PropertyFiltersQueryQuery["propertySearch"]>["sortAndFilter"]>;
  export type Options = NonNullable<
    NonNullable<NonNullable<PropertyFiltersQueryQuery["propertySearch"]>["sortAndFilter"]>["options"]
  >;
  export type _SortAndFilter = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<PropertyFiltersQueryQuery["propertySearch"]>["sortAndFilter"]>["options"]
      >["sortAndFilter"]
    >[number]
  >;
  export type _Options = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<PropertyFiltersQueryQuery["propertySearch"]>["sortAndFilter"]>["options"]
          >["sortAndFilter"]
        >[number]
      >["options"]
    >[number]
  >;
  export type Range = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<NonNullable<PropertyFiltersQueryQuery["propertySearch"]>["sortAndFilter"]>["options"]
            >["sortAndFilter"]
          >[number]
        >["options"]
      >[number]
    >["range"]
  >;
}

export namespace QueryPropertyHeroImage {
  export type Variables = QueryPropertyHeroImageQueryVariables;
  export type Query = QueryPropertyHeroImageQuery;
  export type PropertyInfo = NonNullable<QueryPropertyHeroImageQuery["propertyInfo"]>;
  export type Gallery = NonNullable<NonNullable<QueryPropertyHeroImageQuery["propertyInfo"]>["gallery"]>;
  export type Featured = NonNullable<
    NonNullable<NonNullable<QueryPropertyHeroImageQuery["propertyInfo"]>["gallery"]>["featured"]
  >;
}

export namespace QueryPropertyReviewsHeadline {
  export type Variables = QueryPropertyReviewsHeadlineQueryVariables;
  export type Query = QueryPropertyReviewsHeadlineQuery;
  export type PropertyInfo = NonNullable<QueryPropertyReviewsHeadlineQuery["propertyInfo"]>;
  export type Summary = NonNullable<NonNullable<QueryPropertyReviewsHeadlineQuery["propertyInfo"]>["summary"]>;
  export type Overview = NonNullable<
    NonNullable<NonNullable<QueryPropertyReviewsHeadlineQuery["propertyInfo"]>["summary"]>["overview"]
  >;
  export type Location = NonNullable<
    NonNullable<NonNullable<QueryPropertyReviewsHeadlineQuery["propertyInfo"]>["summary"]>["location"]
  >;
  export type Address = NonNullable<
    NonNullable<
      NonNullable<NonNullable<QueryPropertyReviewsHeadlineQuery["propertyInfo"]>["summary"]>["location"]
    >["address"]
  >;
}

export namespace PropertySearchQuery {
  export type Variables = PropertySearchQueryQueryVariables;
  export type Query = PropertySearchQueryQuery;
  export type PropertySearch = NonNullable<PropertySearchQueryQuery["propertySearch"]>;
  export type Properties = NonNullable<
    NonNullable<NonNullable<PropertySearchQueryQuery["propertySearch"]>["properties"]>[number]
  >;
  export type Gallery = NonNullable<
    NonNullable<
      NonNullable<NonNullable<NonNullable<PropertySearchQueryQuery["propertySearch"]>["properties"]>[number]>["gallery"]
    >[number]
  >;
}

export namespace SingleAdRequestOperation {
  export type Variables = SingleAdRequestOperationQueryVariables;
  export type Query = SingleAdRequestOperationQuery;
  export type SingleAdRequest = NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>;
  export type Marquees = NonNullable<
    NonNullable<NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>["marquees"]>[number]
  >;
  export type CallToAction = NonNullable<
    NonNullable<
      NonNullable<NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>["marquees"]>[number]
    >["callToAction"]
  >;
  export type Logo = NonNullable<
    NonNullable<NonNullable<NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>["marquees"]>[number]>["logo"]
  >;
  export type Image = NonNullable<
    NonNullable<NonNullable<NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>["marquees"]>[number]>["image"]
  >;
  export type Link = NonNullable<
    NonNullable<NonNullable<NonNullable<SingleAdRequestOperationQuery["singleAdRequest"]>["marquees"]>[number]>["link"]
  >;
}

export namespace TravelAgentSearchWizardConfigQuery {
  export type Variables = TravelAgentSearchWizardConfigQueryQueryVariables;
  export type Query = TravelAgentSearchWizardConfigQueryQuery;
  export type TravelAgentSearchWizardConfig = NonNullable<
    TravelAgentSearchWizardConfigQueryQuery["travelAgentSearchWizardConfig"]
  >;
  export type PackageRatesDetail = NonNullable<
    NonNullable<TravelAgentSearchWizardConfigQueryQuery["travelAgentSearchWizardConfig"]>["packageRatesDetail"]
  >;
}
